import * as React from 'react';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function SvgComponent$3T(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2a7.2 7.2 0 01-6-3.22c.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08a7.2 7.2 0 01-6 3.22z"
  }));
}

function SvgComponent$3S(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_32_29)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 14.299a.88.88 0 00.883-.876.88.88 0 00-.883-.876.88.88 0 00-.883.876.88.88 0 00.883.876zm8.552-3.907v-.265c.003-2.866-2-5.35-4.82-5.978-2.819-.627-5.7.77-6.932 3.362a3.382 3.382 0 00-1.957-.616 3.262 3.262 0 00-2.315.908 3.21 3.21 0 00-.987 2.266c0 .254.033.507.096.754A4.63 4.63 0 000 15.353a4.478 4.478 0 001.338 3.212 4.552 4.552 0 003.246 1.307h15.03c2.423 0 4.386-2.053 4.386-4.735 0-2.328-1.477-4.259-3.448-4.745zm-5.104 3.47a.226.226 0 01-.203.188l-.437.024a.285.285 0 00-.237.18l-.171.386a.281.281 0 00.04.293l.293.323a.213.213 0 010 .265l-.6.627a.217.217 0 01-.266 0l-.326-.291a.287.287 0 00-.296-.04l-.392.161c-.1.039-.17.13-.181.236l-.024.433a.226.226 0 01-.19.204 3.194 3.194 0 01-.885 0 .226.226 0 01-.189-.204l-.024-.433a.283.283 0 00-.181-.236l-.392-.161a.287.287 0 00-.296.04l-.326.29a.218.218 0 01-.266 0l-.624-.618a.213.213 0 010-.265l.293-.323a.281.281 0 00.032-.301l-.163-.39a.285.285 0 00-.237-.179l-.445-.018a.226.226 0 01-.206-.188 3.107 3.107 0 010-.879.226.226 0 01.206-.187l.437-.024a.285.285 0 00.237-.18l.171-.394a.281.281 0 00-.04-.294l-.293-.322a.213.213 0 010-.265l.6-.619a.218.218 0 01.266 0l.326.291a.287.287 0 00.296.04l.408-.154c.1-.038.17-.129.181-.235l.024-.434a.226.226 0 01.19-.204c.293-.04.591-.04.885 0 .103.017.18.101.189.204l.024.434c.01.106.081.197.181.235l.392.162a.287.287 0 00.296-.04l.326-.291a.217.217 0 01.266 0l.624.619a.213.213 0 010 .264l-.293.323a.281.281 0 00-.048.286l.163.389c.038.1.13.169.237.18l.437.023c.103.01.187.087.203.188.045.292.047.588.008.881z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_32_29"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))));
}

function SvgComponent$3R(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.08 12H11a1 1 0 011 1v5.15L16.92 12H13a1 1 0 01-1-1V5.85L7.08 12zM11 22a1 1 0 01-1-1v-7H5a1.002 1.002 0 01-.78-1.625l8-10A.999.999 0 0114 3v7h5a1.002 1.002 0 01.78 1.625l-8 10A.998.998 0 0111 22z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$3Q(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M4 11v2h12l-5.5 5.5 1.42 1.42L19.84 12l-7.92-7.92L10.5 5.5 16 11H4z"
  }));
}

function SvgComponent$3P(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M20 11v2H8l5.5 5.5-1.42 1.42L4.16 12l7.92-7.92L13.5 5.5 8 11h12z"
  }));
}

function SvgComponent$3O(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M13.007 11.497a3.82 3.82 0 001.989.542 3.82 3.82 0 001.989-.542 4.075 4.075 0 001.45-1.456c.36-.61.539-1.276.539-1.998a3.99 3.99 0 00-.54-2.021 4.018 4.018 0 00-1.45-1.48A3.821 3.821 0 0014.997 4c-.72 0-1.382.18-1.99.542a4.02 4.02 0 00-1.45 1.48c-.359.625-.539 1.3-.539 2.021 0 .722.18 1.388.54 1.998.36.61.842 1.095 1.45 1.456z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.009 10.017h2.995v2.022H6.01v3.008H3.996v-3.008H1v-2.022h2.996V7.008h2.013v3.009z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.996 14.06c.99 0 2.077.144 3.259.433 1.342.337 2.428.787 3.26 1.348.99.658 1.485 1.396 1.485 2.214v2.022H6.991v-2.022c0-.818.496-1.556 1.486-2.214.83-.561 1.917-1.01 3.26-1.348 1.182-.289 2.268-.433 3.259-.433z"
  }));
}

function SvgComponent$3N(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.037 11.96c1.61 0 3.338-2.14 3.338-4.338S13.881 4 12.037 4s-3.34 1.424-3.34 3.622 1.677 4.338 3.34 4.338zM7.362 8.58c0 1.434-1.127 2.829-2.177 2.829-1.084 0-2.177-1.396-2.177-2.829 0-1.433.975-2.362 2.177-2.362 1.203 0 2.177.929 2.177 2.362zm13.63 0c0 1.434-1.128 2.829-2.178 2.829-1.084 0-2.177-1.396-2.177-2.829 0-1.433.975-2.362 2.177-2.362 1.203 0 2.178.929 2.178 2.362zm-4.228 5.349c.548.57.842.973 1.245 1.772.203.402.625 1.571.363 2.075-.331.637-1.137.9-3.352 1.171-1.327.162-2.983.162-2.983.162s-1.657 0-2.984-.162c-2.215-.27-3.02-.534-3.352-1.171-.261-.504.16-1.673.363-2.075.403-.8.697-1.203 1.245-1.772.474-.492 1.887-1.186 2.8-.88.277.06.454.158.63.257.288.16.576.32 1.298.32.721 0 1.01-.16 1.297-.32.177-.099.353-.197.63-.258.913-.305 2.326.389 2.8.881zm5.945-.08a4.089 4.089 0 00-.812-1.156c-.309-.321-1.23-.774-1.825-.575-.181.04-.297.104-.412.169-.187.104-.375.209-.845.209s-.659-.105-.846-.21c-.115-.064-.23-.128-.411-.168-.479-.16-1.167.101-1.58.377.568.233 1.072.558 1.372.87.624.648.96 1.127 1.386 1.97.083.164.194.428.293.734.358-.005 1.1-.026 1.73-.104 1.445-.176 1.97-.348 2.187-.763.17-.329-.105-1.092-.237-1.353zm-15.986-.484c-.623.648-.96 1.127-1.385 1.97a5.969 5.969 0 00-.297.735 18.347 18.347 0 01-1.801-.105c-1.445-.176-1.97-.348-2.186-.763-.17-.329.105-1.091.236-1.353.264-.522.455-.784.813-1.156.309-.321 1.23-.773 1.825-.574.181.04.296.103.411.168.188.104.376.209.846.209s.659-.105.846-.21a1.38 1.38 0 01.411-.167c.49-.164 1.2.113 1.608.395-.549.232-1.034.547-1.327.85z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$3M(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M19 17v2H7v-2s0-4 6-4 6 4 6 4zm-3-9a3 3 0 10-6 0 3 3 0 006 0zm3.2 5.06A5.6 5.6 0 0121 17v2h3v-2s0-3.45-4.8-3.94zM18 5a2.91 2.91 0 00-.89.14 5 5 0 010 5.72c.288.093.588.14.89.14a3 3 0 000-6zM8 10H5V7H3v3H0v2h3v3h2v-3h3v-2z"
  }));
}

function SvgComponent$3L(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M14.02 6.99V5.02H9.98v1.97h4.04zm6.009 0c.545 0 1.01.2 1.394.601.385.401.577.874.577 1.419v3.004a1.98 1.98 0 01-.577 1.419c-.384.4-.85.6-1.394.6h-6.01v-2.019H9.981v2.02H3.97a1.87 1.87 0 01-1.406-.59A1.99 1.99 0 012 12.015V9.01c0-.545.192-1.018.577-1.419.385-.4.85-.6 1.394-.6h3.99V5.018L9.982 3h3.99l2.02 2.02v1.97h4.038zM9.98 16.005h4.038v-.986h6.995v3.99c0 .561-.196 1.038-.588 1.43-.393.393-.87.59-1.43.59H5.004c-.561 0-1.038-.197-1.43-.59a1.947 1.947 0 01-.59-1.43v-3.99h6.996v.986z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$3K(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M16 17v2H2v-2s0-4 7-4 7 4 7 4zm-3.5-9.5a3.5 3.5 0 10-7 0 3.5 3.5 0 007 0zm3.44 5.5A5.32 5.32 0 0118 17v2h4v-2s0-3.63-6.06-4zM15 4a3.39 3.39 0 00-1.93.59 5 5 0 010 5.82A3.39 3.39 0 0015 11a3.5 3.5 0 000-7z"
  }));
}

function SvgComponent$3J(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4 21a2 2 0 01-2-2V5c0-1.11.89-2 2-2h1V1h2v2h8V1h2v2h1a2 2 0 012 2v6.1c1.24 1.26 2 2.99 2 4.9a7 7 0 01-7 7c-1.91 0-3.64-.76-4.9-2H4zM4 8h14v1.67c-.91-.43-1.93-.67-3-.67a7 7 0 00-7 7c0 1.07.24 2.09.67 3H4V8zm11.5 5H14v3.69l3.19 1.84.75-1.3-2.44-1.41V13zm-5.35 3a4.85 4.85 0 119.7 0 4.85 4.85 0 01-9.7 0z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$3I(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2.833 4C2.373 4 2 4.358 2 4.8v14.4c0 .442.373.8.833.8h18.334c.46 0 .833-.358.833-.8V4.8c0-.442-.373-.8-.833-.8H2.833zm11.25 5.6c0 1.105-.932 2-2.083 2-1.15 0-2.083-.895-2.083-2s.932-2 2.083-2c1.15 0 2.083.895 2.083 2zm2.081 6.398c0-2.141-1.921-3.998-4.165-3.998-2.243 0-4.166 1.857-4.166 3.998h8.331z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$3H(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M15.796 13.497a.157.157 0 00-.043-.15.157.157 0 00-.116-.05h-.982c-.075 0-.126.04-.154.118-.143.341-.233.54-.27.599a2.58 2.58 0 01-.952.915 2.573 2.573 0 01-1.279.333c-.33 0-.65-.062-.957-.184a2.639 2.639 0 01-.823-.522l.7-.7a.315.315 0 00.098-.231.315.315 0 00-.097-.23.315.315 0 00-.23-.097H8.399a.315.315 0 00-.23.097.315.315 0 00-.098.23v2.292c0 .088.033.165.098.23a.314.314 0 00.23.097.315.315 0 00.23-.097l.66-.66a3.906 3.906 0 002.69 1.084c.935 0 1.75-.284 2.446-.851.695-.568 1.152-1.309 1.37-2.223z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.929 11.66V9.37a.315.315 0 00-.098-.23.315.315 0 00-.23-.097.315.315 0 00-.23.097l-.665.66a3.963 3.963 0 00-1.253-.8A3.86 3.86 0 0012 8.713c-.938 0-1.756.284-2.455.852-.7.568-1.16 1.309-1.381 2.223v.035c0 .045.016.083.048.116.033.032.07.048.115.048h1.018c.075 0 .126-.04.154-.118a6.2 6.2 0 01.27-.598 2.58 2.58 0 01.952-.916A2.573 2.573 0 0112 10.024c.685 0 1.28.233 1.785.7l-.706.707a.315.315 0 00-.097.23c0 .088.033.165.097.23a.315.315 0 00.23.097h2.292a.315.315 0 00.23-.097.315.315 0 00.098-.23z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.652 4c-.686 0-1.292.444-1.499 1.098l-.232.735h-3.35C1.704 5.833 1 6.537 1 7.405v11.524c0 .868.704 1.571 1.571 1.571H21.43c.867 0 1.571-.703 1.571-1.571V7.405c0-.868-.704-1.572-1.571-1.572h-3.35l-.232-.735A1.571 1.571 0 0016.348 4H7.652zm-.58 3.405l.58-1.834h8.696l.58 1.834h4.5v11.524H2.572V7.405h4.502z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$3G(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3.288 1.616L21 19.328 19.728 20.6l-3.168-3.192a1.032 1.032 0 01-.576.192h-12a.948.948 0 01-.696-.288.948.948 0 01-.288-.696V6.584c0-.272.096-.504.288-.696a.948.948 0 01.696-.288h.744L2.016 2.888l1.272-1.272zM21 6.104v10.704L9.792 5.6h6.192c.288 0 .532.096.732.288.2.192.3.424.3.696v3.504L21 6.104z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$3F(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M20 7.438l-3.269 3.03V7.913a.92.92 0 00-.246-.646.786.786 0 00-.6-.267H4.806a.736.736 0 00-.57.267.941.941 0 00-.237.646v8.612c0 .253.079.468.236.646a.736.736 0 00.571.267h11.077c.237 0 .437-.089.6-.267a.92.92 0 00.247-.646v-3.273L20 16.282V7.438zm-8.667 2.22v2h2v1.332h-2v2H10v-2H8v-1.333h2v-2h1.333z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$3E(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16.18 15l-3-3 3-3L15 7.82l-3 3-3-3L7.82 9l3 3-3 3L9 16.18l3-3 3 3L16.18 15zM12 3.68c1.52 0 2.927.38 4.22 1.14a7.886 7.886 0 012.96 2.96A8.182 8.182 0 0120.32 12c0 1.52-.38 2.927-1.14 4.22a7.886 7.886 0 01-2.96 2.96A8.182 8.182 0 0112 20.32c-1.52 0-2.927-.38-4.22-1.14a8.035 8.035 0 01-2.96-2.98A8.146 8.146 0 013.68 12c0-1.507.38-2.907 1.14-4.2A8.188 8.188 0 017.8 4.82 8.146 8.146 0 0112 3.68z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$3D(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12 8H4a2 2 0 00-2 2v4a2 2 0 002 2h1v4a1 1 0 001 1h2a1 1 0 001-1v-4h3l5 4V4l-5 4zm9.5 4c0 1.71-.96 3.26-2.5 4V8c1.53.75 2.5 2.3 2.5 4z"
  }));
}

function SvgComponent$3C(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M2 3h20c1.05 0 2 .95 2 2v14c0 1.05-.95 2-2 2H2c-1.05 0-2-.95-2-2V5c0-1.05.95-2 2-2zm12 3v1h8V6h-8zm0 2v1h8V8h-8zm0 2v1h7v-1h-7zm-6 3.91C6 13.91 2 15 2 17v1h12v-1c0-2-4-3.09-6-3.09zM8 6a3 3 0 100 6 3 3 0 000-6z"
  }));
}

function SvgComponent$3B(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$3A(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M16.522 12a.823.823 0 01-.282.627.88.88 0 01-.649.26h-9L3 16.522V3.887c0-.245.087-.454.26-.627A.855.855 0 013.887 3h11.704a.88.88 0 01.65.26.823.823 0 01.28.627V12zm3.591-5.409c.245 0 .454.087.627.26.174.173.26.382.26.627V21l-3.591-3.591h-9.93a.855.855 0 01-.628-.26.855.855 0 01-.26-.627v-1.818h11.705V6.591h1.817z"
  }));
}

function SvgComponent$3z(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10.16 13.86c0-.48.12-.93.36-1.35.24-.42.563-.75.97-.99.407-.24.85-.36 1.33-.36.48 0 .927.123 1.34.37.413.247.743.577.99.99.247.413.37.86.37 1.34 0 .48-.12.923-.36 1.33-.24.407-.57.73-.99.97-.42.24-.87.36-1.35.36-.48 0-.923-.12-1.33-.36a2.705 2.705 0 01-.97-.97 2.57 2.57 0 01-.36-1.33zM12.82 18a4.15 4.15 0 003.62-2.06c.373-.64.56-1.337.56-2.09 0-.753-.187-1.45-.56-2.09a4.154 4.154 0 00-1.52-1.52 4.075 4.075 0 00-2.09-.56c-.753 0-1.45.187-2.09.56a4.15 4.15 0 00-2.06 3.62 4.097 4.097 0 002.05 3.59c.633.367 1.33.55 2.09.55zM7 10.5V8h2.5V5.5h5.82l1.52 1.68h2.66c.453 0 .847.167 1.18.5.333.333.5.727.5 1.18v10c0 .453-.167.84-.5 1.16-.333.32-.727.48-1.18.48H6.18c-.453 0-.847-.16-1.18-.48a1.55 1.55 0 01-.5-1.16V10.5H7zm-2.5-5V3h1.68v2.5h2.5v1.68h-2.5v2.5H4.5v-2.5H2V5.5h2.5z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$3y(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.13 12.656a.404.404 0 00-.13.285c0 .115.043.23.13.3a.419.419 0 00.559 0l4.305-4.258 4.29 4.259c.172.142.43.142.603 0 .158-.158.143-.43 0-.586l-4.592-4.517-.014-.014-.043-.043c-.015-.014-.043-.028-.072-.043-.043-.014-.072-.028-.1-.028a.2.2 0 00-.13 0 .13.13 0 00-.072.014c-.014 0-.028 0-.043.014 0 0-.014 0-.028.015a.38.38 0 00-.086.071l-.015.014-4.563 4.517z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$3x(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.344 7.13A.404.404 0 0011.06 7a.388.388 0 00-.3.13.419.419 0 000 .559l4.258 4.305-4.259 4.29a.477.477 0 000 .603c.158.158.43.143.586 0l4.517-4.592.014-.014.043-.043a.312.312 0 00.043-.072c.014-.043.028-.072.028-.1a.2.2 0 000-.13c0-.028 0-.043-.014-.072 0-.014 0-.028-.014-.043 0 0 0-.014-.015-.028-.014-.029-.043-.058-.071-.086l-.014-.015-4.517-4.563z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$3w(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16.87 11.344a.404.404 0 00.13-.285.388.388 0 00-.13-.3.419.419 0 00-.559 0l-4.305 4.258-4.29-4.259a.477.477 0 00-.603 0c-.158.158-.143.43 0 .586l4.592 4.517.014.014.043.043a.312.312 0 00.072.043c.043.014.072.028.1.028a.2.2 0 00.13 0c.028 0 .043 0 .072-.014.014 0 .028 0 .043-.014 0 0 .014 0 .028-.015.029-.014.058-.043.086-.071l.015-.014 4.563-4.517z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$3v(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M9 7c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm7-7H2a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2V2a2 2 0 00-2-2zm-1.75 9c0 .23-.02.46-.05.68l1.48 1.16c.13.11.17.3.08.45l-1.4 2.42c-.09.15-.27.21-.43.15l-1.74-.7c-.36.28-.76.51-1.18.69l-.26 1.85c-.03.17-.18.3-.35.3H7.6c-.17 0-.32-.13-.35-.29l-.26-1.85c-.43-.18-.82-.41-1.18-.69l-1.74.7c-.16.06-.34 0-.43-.15l-1.4-2.42a.353.353 0 01.08-.45L3.8 9.69c-.03-.23-.05-.46-.05-.69 0-.23.02-.46.05-.68L2.32 7.16a.353.353 0 01-.08-.45l1.4-2.42c.09-.15.27-.21.43-.15l1.74.7c.36-.28.76-.51 1.18-.69l.26-1.85c.03-.17.18-.3.35-.3h2.8c.17 0 .32.13.35.29l.26 1.85c.43.18.82.41 1.18.69l1.74-.7c.16-.06.34 0 .43.15l1.4 2.42c.09.15.05.34-.08.45L14.2 8.31c.03.23.05.46.05.69z"
  }));
}

function SvgComponent$3u(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$3t(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.656 16.87c.085.087.185.13.285.13a.388.388 0 00.3-.13.419.419 0 000-.559l-4.258-4.305 4.259-4.29a.477.477 0 000-.603c-.158-.158-.43-.143-.586 0l-4.517 4.592-.014.014-.043.043c-.014.015-.028.043-.043.072-.014.043-.028.072-.028.1a.2.2 0 000 .13c0 .028 0 .043.014.072 0 .014 0 .028.014.043 0 0 0 .014.015.028a.38.38 0 00.071.086l.014.015 4.517 4.563z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$3s(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12 15.5a3.5 3.5 0 110-7 3.5 3.5 0 010 7zm7.43-2.53c.04-.32.07-.64.07-.97 0-.33-.03-.66-.07-1l2.11-1.63c.19-.15.24-.42.12-.64l-2-3.46c-.12-.22-.39-.31-.61-.22l-2.49 1c-.52-.39-1.06-.73-1.69-.98l-.37-2.65A.506.506 0 0014 2h-4c-.25 0-.46.18-.5.42l-.37 2.65c-.63.25-1.17.59-1.69.98l-2.49-1c-.22-.09-.49 0-.61.22l-2 3.46c-.13.22-.07.49.12.64L4.57 11c-.04.34-.07.67-.07 1 0 .33.03.65.07.97l-2.11 1.66c-.19.15-.25.42-.12.64l2 3.46c.12.22.39.3.61.22l2.49-1.01c.52.4 1.06.74 1.69.99l.37 2.65c.04.24.25.42.5.42h4c.25 0 .46-.18.5-.42l.37-2.65c.63-.26 1.17-.59 1.69-.99l2.49 1.01c.22.08.49 0 .61-.22l2-3.46c.12-.22.07-.49-.12-.64l-2.11-1.66z"
  }));
}

function SvgComponent$3r(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M23 5.498L5.421 9.788v12.554L23 18.085V5.498zm-.78 11.835L6.311 21.242v-10.69l15.907-3.91v10.691z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M21.186 4.12a.534.534 0 00-.645-.39L3.566 7.9a.533.533 0 00-.406.519v11.79a.533.533 0 001.067 0V8.837l16.569-4.071c.285-.07.46-.36.39-.646z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M19.026 2.406a.534.534 0 00-.645-.39L1.406 6.186A.533.533 0 001 6.706v11.79a.533.533 0 001.067 0V7.122l16.569-4.072a.533.533 0 00.39-.645z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M14.265 18.174a.533.533 0 00.533-.533v-7.398a.533.533 0 10-1.066 0v7.398c0 .295.238.533.533.533z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.963 13.701a.546.546 0 00.128-.016l4.115-1.01a.533.533 0 10-.255-1.037L7.836 12.65a.533.533 0 00.127 1.052z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.963 16.024a.544.544 0 00.128-.015l4.115-1.012a.533.533 0 10-.255-1.036l-4.115 1.012a.533.533 0 00.127 1.051z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.963 18.348a.535.535 0 00.128-.016l4.115-1.01a.533.533 0 10-.255-1.037l-4.115 1.011a.533.533 0 00.127 1.052z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M18.703 11.659l2.498-.796-.204-2.482-2.35.367.056 2.91zm.604-1.975l.828-.203v.964l-.828.203v-.964z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$3q(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.8 3h14.4A1.8 1.8 0 0121 4.8v10.8a1.8 1.8 0 01-1.8 1.8h-5.49l-3.33 3.339a.917.917 0 01-.63.261H9.3a.9.9 0 01-.9-.9v-2.7H4.8A1.8 1.8 0 013 15.6V4.8C3 3.801 3.81 3 4.8 3zm7.371 3.15c-.801 0-1.44.162-1.926.486-.495.324-.747.864-.702 1.485h1.773c0-.252.09-.441.234-.567.18-.126.378-.189.621-.189.279 0 .522.072.684.234.162.153.243.351.243.621 0 .252-.072.477-.198.666-.153.198-.342.36-.576.486-.468.288-.774.54-.963.756-.171.216-.261.522-.261.972h1.8c0-.252.045-.45.126-.612.081-.153.234-.288.468-.423a2.737 2.737 0 001.017-.765c.261-.333.396-.684.396-1.08 0-.63-.243-1.134-.729-1.512-.486-.369-1.161-.558-2.007-.558zM11.1 13.8V12h1.8v1.8h-1.8z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$3p(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M17.32 14v1.68h-1.68V14h1.68zm0-3.32v1.64h-1.68v-1.64h1.68zM19 17.32V9h-6.68v1.68H14v1.64h-1.68V14H14v1.68h-1.68v1.64H19zm-8.36-10V5.68H9v1.64h1.64zm0 3.36V9H9v1.68h1.64zm0 3.32v-1.68H9V14h1.64zm0 3.32v-1.64H9v1.64h1.64zm-3.32-10V5.68H5.64v1.64h1.68zm0 3.36V9H5.64v1.68h1.68zm0 3.32v-1.68H5.64V14h1.68zm0 3.32v-1.64H5.64v1.64h1.68zm5-10h8.32V19H4V4h8.32v3.32z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$3o(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M19.14 12.936c.036-.3.06-.612.06-.936 0-.324-.024-.636-.072-.936l2.028-1.584a.496.496 0 00.12-.612l-1.92-3.324a.488.488 0 00-.588-.216l-2.388.96a7.03 7.03 0 00-1.62-.936l-.36-2.544a.479.479 0 00-.48-.408h-3.84a.467.467 0 00-.468.408l-.36 2.544a7.218 7.218 0 00-1.62.936l-2.388-.96a.475.475 0 00-.588.216l-1.92 3.324a.465.465 0 00.12.612l2.028 1.584c-.048.3-.084.624-.084.936 0 .312.024.636.072.936L2.844 14.52a.496.496 0 00-.12.612l1.92 3.324c.12.216.372.288.588.216l2.388-.96a7.03 7.03 0 001.62.936l.36 2.544c.048.24.24.408.48.408h3.84c.24 0 .444-.168.468-.408l.36-2.544a7.219 7.219 0 001.62-.936l2.388.96c.216.084.468 0 .588-.216l1.92-3.324a.465.465 0 00-.12-.612l-2.004-1.584zM12 15.6A3.61 3.61 0 018.4 12c0-1.98 1.62-3.6 3.6-3.6s3.6 1.62 3.6 3.6-1.62 3.6-3.6 3.6z"
  }));
}

function SvgComponent$3n(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.032 12.547a9.716 9.716 0 013.432-2.232 10.023 10.023 0 013.888-.624l-1.32 2.856a6.81 6.81 0 00-2.148.66A7.098 7.098 0 007 14.563l-1.968-2.016zm12 2.016a8.006 8.006 0 00-1.224-.984l.576-2.904A9.578 9.578 0 0119 12.547l-1.968 2.016zm3.984-3.984c-1.232-1.248-2.608-2.168-4.128-2.76l.528-2.808a14.995 14.995 0 015.616 3.552l-2.016 2.016zM1 8.563a15.333 15.333 0 016.456-3.888 15.536 15.536 0 017.272-.432l-1.152 2.688a12.43 12.43 0 00-5.616.576 12.64 12.64 0 00-4.944 3.072L1 8.563zm14.904-3.984c.144 0 .268.044.372.132a.409.409 0 01.156.324l-2.448 12.912v.048a1.943 1.943 0 01-.708 1.128 1.954 1.954 0 01-1.26.456c-.56 0-1.036-.196-1.428-.588A1.944 1.944 0 0110 17.563c0-.336.08-.664.24-.984l5.208-11.616c.08-.256.232-.384.456-.384z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$3m(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M23 11.8c0 3.667-2.05 6.906-5.11 8.739-.065.061-.162.061-.26.061H6.402a.646.646 0 01-.26-.061C3.05 18.706 1 15.467 1 11.8c0-3.667 2.05-6.906 5.142-8.739C6.207 3 6.305 3 6.402 3H17.63c.098 0 .195.03.26.061C20.95 4.894 23 8.133 23 11.8zM8.673 9.6h-.68c-.214 0-.393.131-.393.288v3.824c0 .157.179.288.394.288h.68c.214 0 .393-.131.393-.288V9.888c0-.157-.18-.288-.394-.288zm7.333 0h-.68c-.214 0-.393.168-.393.37v3.66c0 .202.18.37.394.37h.68c.214 0 .393-.168.393-.37V9.97c0-.202-.179-.37-.393-.37z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$3l(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M18.403 20.17V7.447H8.447V20.17h9.956zm0-14.51c.494 0 .922.174 1.286.523.363.349.544.77.544 1.264V20.17c0 .494-.181.922-.544 1.285a1.758 1.758 0 01-1.286.545H8.447c-.494 0-.923-.181-1.286-.545a1.758 1.758 0 01-.544-1.285V7.447c0-.494.181-.915.544-1.264a1.795 1.795 0 011.286-.523h9.956zM15.68 2v1.83H4.786v12.723H3V3.83c0-.494.174-.922.523-1.285C3.87 2.182 4.293 2 4.786 2H15.68z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$3k(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"
  }));
}

function SvgComponent$3j(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M19 1l-1.26 2.75L15 5l2.74 1.26L19 9l1.25-2.74L23 5l-2.75-1.25L19 1zM9 4L6.5 9.5 1 12l5.5 2.5L9 20l2.5-5.5L17 12l-5.5-2.5L9 4zm10 11l-1.26 2.74L15 19l2.74 1.25L19 23l1.25-2.75L23 19l-2.75-1.26"
  }));
}

function SvgComponent$3i(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z"
  }));
}

function SvgComponent$3h(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15 1h1.007L21 5.993V23H3V1h12zM4 22h16V7h-5V2H4v20zM16 6V2.407L19.593 6H16zM9.198 16.097c.315 0 .574-.049.707-.112l-.092-.771c-.112.035-.287.07-.441.07-.559 0-.987-.441-.987-1.569 0-1.17.469-1.618.987-1.618.203 0 .323.042.428.091l.155-.77c-.092-.063-.316-.126-.638-.126-.917 0-1.905.694-1.905 2.473 0 1.345.574 2.332 1.786 2.332zm1.455-.981c.189.105.519.182.777.182.428 0 .645-.224.645-.532 0-.343-.21-.511-.609-.771-.644-.392-.889-.89-.889-1.317 0-.756.504-1.387 1.484-1.387.315 0 .609.084.742.168l-.146.792a1.123 1.123 0 00-.596-.161c-.393 0-.581.238-.581.491 0 .28.14.427.644.735.631.378.854.854.854 1.352 0 .861-.637 1.429-1.555 1.429-.378 0-.742-.098-.903-.189l.133-.792zm2.82-3.782l1.051 4.721h1.03l1.079-4.721h-1.009l-.322 2.017a36.419 36.419 0 00-.224 1.66h-.015a28.409 28.409 0 00-.17-1.197l-.067-.442-.337-2.038h-1.016z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$3g(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M11 13H3V3h8v10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 21H3v-6h8v6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 21h8V11h-8v10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 9V3h8v6h-8z"
  }));
}

function SvgComponent$3f(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16_101)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2.893 1.05L2.02 5.448H19.9l-.562 2.827H1.442l-.858 4.397h17.881l-1.007 5.017-7.193 2.384-6.247-2.384.43-2.175H.05L-1 20.782l10.332 3.952 11.9-3.952L25.17 1.051H2.893z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16_101"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))));
}

function SvgComponent$3e(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.18 12l-5-5L6 8.18 9.84 12 6 15.82 7.18 17l5-5zm6 0l-5-5L12 8.18 15.84 12 12 15.82 13.18 17l5-5z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$3d(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M18.968 3.984V6H5V3.984h3.48L9.512 3h4.968l1.032.984h3.456zm-12.984 15v-12h12v12c0 .544-.2 1.016-.6 1.416-.4.4-.872.6-1.416.6H8c-.544 0-1.016-.2-1.416-.6-.4-.4-.6-.872-.6-1.416z"
  }));
}

function SvgComponent$3c(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M21 13.616V3.584H3v10.032h18zm0-12c.544 0 1.016.192 1.416.576.4.384.6.848.6 1.392v12c0 .544-.2 1.016-.6 1.416-.4.4-.872.6-1.416.6h-6.984l1.968 3v.984H8.016V20.6l1.968-3H3c-.544 0-1.016-.2-1.416-.6-.4-.4-.6-.872-.6-1.416v-12c0-.544.2-1.008.6-1.392.4-.384.872-.576 1.416-.576h18z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$3b(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9.376 10.6l.9.76c.12.08.147.153.08.22l-.82 1.46c-.053.04-.133.06-.24.06l-1.08-.42-.38.24a1.487 1.487 0 01-.36.18l-.2 1.06-.12.12c-.04.053-.08.08-.12.08h-1.68c-.04 0-.087-.023-.14-.07-.053-.047-.06-.09-.02-.13l-.16-1.06a1.487 1.487 0 01-.36-.18l-.38-.24-1.16.36c-.067.04-.16 0-.28-.12l-.82-1.42c0-.093.027-.193.08-.3l.94-.66v-.86L2.116 9l-.1-.12c-.027-.027-.02-.06.02-.1l.82-1.46c.053-.053.147-.08.28-.08l1.04.44c.347-.227.613-.373.8-.44l.14-1.04.12-.14c.053-.04.093-.06.12-.06h1.68c.08 0 .14.02.18.06.04.04.06.087.06.14l.2 1.04c.12.04.367.187.74.44l1.08-.36c.04-.04.08-.04.12 0l.12.12.82 1.42a.297.297 0 01-.08.22l-.9.66v.86zm1.803 1.556c.444-.568.205-1.221-.29-1.587l-.443-.374.421-.309.116-.099c.253-.253.373-.582.373-.927v-.268l-.238-.412h5.738c.24 0 .443.08.61.24.167.16.25.353.25.58v2.92l3.32-3.32v9.14l-3.32-3.32v2.94c0 .227-.083.42-.25.58a.848.848 0 01-.61.24h-10a.79.79 0 01-.58-.24.79.79 0 01-.24-.58v-2h1c.375 0 .657-.167.864-.41l.301-.301.159-.84.748.291h.188c.304 0 .588-.07.84-.26l.169-.127.874-1.557zm-3.803-.796c-.32.333-.707.5-1.16.5-.453 0-.847-.167-1.18-.5a1.614 1.614 0 01-.5-1.18c0-.453.167-.847.5-1.18.333-.333.727-.5 1.18-.5.453 0 .84.167 1.16.5.32.333.48.727.48 1.18 0 .453-.16.847-.48 1.18z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$3a(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_686_13039)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2 4.8a.86.86 0 01.8-.8h18.35a.79.79 0 01.8.8v14.4a.86.86 0 01-.8.8H2.85a.791.791 0 01-.8-.8L2 4.8zm1.7 1.6a.8.8 0 011.6 0V8a.8.8 0 01-1.6 0V6.4zm0 4.8a.8.8 0 011.6 0v1.6a.8.8 0 11-1.6 0v-1.6zm.8 4a.791.791 0 00-.8.8v1.6a.8.8 0 001.6 0V16a.79.79 0 00-.8-.8zm14.2-8.8a.8.8 0 011.6 0V8a.8.8 0 11-1.6 0V6.4zm.8 4a.79.79 0 00-.8.8v1.6a.8.8 0 101.6 0v-1.6a.789.789 0 00-.8-.8zm-.8 5.6a.8.8 0 111.6 0v1.6a.8.8 0 11-1.6 0V16zm-4.65-5.92a2.1 2.1 0 11-2.1-2 2 2 0 012.1 2zm2.1 6.4a4.19 4.19 0 00-4.2-4 4.26 4.26 0 00-4.2 4h8.4z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_686_13039"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h19.9v16H0z",
    transform: "translate(2 4)"
  }))));
}

function SvgComponent$39(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M3 13h4V4H3z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M19.889 14.835H16.94c0 1.315.026 4.148-.176 5.393C16.48 21.98 15.864 22 15.119 22c-1.275 0-1.374-1.857-2.011-4.491-.571-2.36-3.305-4.173-5.108-4.528V4.315h3.204C12.48 4.315 11.841 3 13.116 3h5.737C22.04 3 22 6.314 22 6.314v6.31c0 1.29-.837 2.211-2.111 2.211z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$38(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M6 19h12v-1.765H6V19zm12-9.706h-3.429V4H9.43v5.294H6l6 6.177 6-6.177z"
  }));
}

function SvgComponent$37(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"
  }));
}

function SvgComponent$36(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M15.659 11.97H8.753l-.587 2.475h8.08l-.587-2.475z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.595 7.484H9.817L9.23 9.959h5.951l-.586-2.475z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.584 3.224l-.004-.018a.236.236 0 00-.228-.177H11.06a.236.236 0 00-.23.183l-.002.008-.534 2.253h3.824l-.534-2.249z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.153 18.9h-.851l-.58-2.445H7.69L7.11 18.9h-.85c-.569 0-1.03.46-1.03 1.029v1.042h13.953v-1.043a1.03 1.03 0 00-1.029-1.028z"
  }));
}

function SvgComponent$35(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M19.76 7.36l-1.52 1.52-3.12-3.12 1.52-1.52c.16-.16.357-.24.59-.24.233 0 .43.08.59.24l1.94 1.94c.16.16.24.357.24.59 0 .233-.08.43-.24.59zM5 15.88l9.22-9.22 3.12 3.12L8.12 19H5v-3.12z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$34(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M18.68 8.68V7L12 11.18 5.32 7v1.68L12 12.82l6.68-4.14zm0-3.36c.453 0 .84.167 1.16.5.32.333.48.727.48 1.18v10c0 .453-.16.847-.48 1.18-.32.333-.707.5-1.16.5H5.32a1.55 1.55 0 01-1.16-.5A1.647 1.647 0 013.68 17V7c0-.453.16-.847.48-1.18.32-.333.707-.5 1.16-.5h13.36z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$33(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15.437 3.729v1.729l-6.874 4.26-6.875-4.26V3.729l6.875 4.302 6.874-4.302zm1.194-1.214A1.594 1.594 0 0015.437 2H1.687c-.466 0-.864.172-1.193.515C.164 2.858 0 3.262 0 3.729v10.292c0 .466.165.87.494 1.214.33.343.727.515 1.194.515h8.608a7.72 7.72 0 016.83-8.198V3.728c0-.467-.165-.871-.495-1.214z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M24 15.221a6.003 6.003 0 11-12.007 0 6.003 6.003 0 0112.007 0zm-9.295-1.43l2.315 2.377 4.264-4.377 1 1.028-5.263 5.404-3.313-3.373.997-1.06z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9.065 17.586l-.617.618a.39.39 0 01-.568 0l-5.756-5.756a.39.39 0 010-.569L7.88 6.125a.39.39 0 01.568 0l.617.617a.39.39 0 010 .568l-4.854 4.855 4.854 4.854a.39.39 0 010 .568zm12.812-5.138l-5.756 5.756a.39.39 0 01-.569 0l-.617-.618a.39.39 0 010-.568l4.854-4.854-4.854-4.855a.39.39 0 010-.568l.617-.617a.39.39 0 01.569 0l5.756 5.756a.39.39 0 010 .568z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$31(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.986 12.986v-6.01h-1.972v6.01h1.972zm0 4.038v-2.02h-1.972v2.02h1.972zM12 2c1.827 0 3.518.457 5.072 1.37a9.478 9.478 0 013.558 3.558A9.834 9.834 0 0122 12a9.834 9.834 0 01-1.37 5.072 9.478 9.478 0 01-3.558 3.558A9.834 9.834 0 0112 22a9.834 9.834 0 01-5.072-1.37 9.657 9.657 0 01-3.558-3.582A9.791 9.791 0 012 12a9.79 9.79 0 011.37-5.048A9.842 9.842 0 016.952 3.37 9.79 9.79 0 0112 2z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$30(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipPath: "url(#clip0_686_13040)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9 14.2V3.8a.86.86 0 00-.8-.8H1.85a.79.79 0 00-.8.8v10.4a.86.86 0 00.8.8h14.3a.79.79 0 00.75-.8zM9 4.6a2 2 0 11-.2 3.995A2 2 0 019 4.6zM4.8 13A4.26 4.26 0 019 9a4.19 4.19 0 014.2 4H4.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2 17.5V7.32a.79.79 0 00-.8-.8h-1v10H3.5v1a.79.79 0 00.8.8h15.1a.79.79 0 00.8-.82z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.69 9.81h-1v10H6.79v1a.789.789 0 00.8.8h15.1a.788.788 0 00.8-.8V10.62a.79.79 0 00-.8-.81z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_686_13040"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h22.49v18.59H0z",
    transform: "translate(1 3)"
  }))));
}

function SvgComponent$2$(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16 1H3v22h18V5.993L16.007 1H16zm4 21H4V2h11v5h5v15zM16 2.407V6h3.593L16 2.407z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.796 17.839H16l-2.898-4.28L15.511 10h-2.205L12 11.93 10.693 10H8.488l2.41 3.558L8 17.838h4.79l-.78-1.265h-.95l.94-1.387 1.796 2.653z"
  }));
}

function SvgComponent$2_(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.199 2l4.255 4.234 2.637-2.63v7.487H3.572l2.68-2.663L2 4.19 4.199 2zm15.32 10.91l-2.677 2.665 4.249 4.232L18.889 22l-4.25-4.232L12 20.398v-7.489h7.52z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$2Z(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12 9a3 3 0 100 6 3 3 0 000-6zm0 8a5 5 0 110-10 5 5 0 010 10zm0-12.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5z"
  }));
}

function SvgComponent$2Y(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M20 8l-8 5-8-5V6l8 5 8-5v2zm0-4H4c-1.11 0-2 .89-2 2v12a2 2 0 002 2h16a2 2 0 002-2V6a2 2 0 00-2-2z"
  }));
}

function SvgComponent$2X(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M13 9h5.5L13 3.5V9zM6 2h8l6 6v12a2 2 0 01-2 2H6a2 2 0 01-2-2V4c0-1.11.89-2 2-2zm9 16v-2H6v2h9zm3-4v-2H6v2h12z"
  }));
}

function SvgComponent$2W(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.564 8.425h-2.416a3.624 3.624 0 01-2.637 2.703v2.547h2.726v7.237H3v-7.237h2.902v-2.507a3.62 3.62 0 114.246-4.353h2.416L16.38 3 21 7.62l-3.816 3.816v2.416A3.62 3.62 0 0116.38 21a3.619 3.619 0 01-.805-7.148v-2.416l-3.01-3.011zm3.815-3.15l2.344 2.345-2.344 2.344-2.344-2.344 2.344-2.344zM8.63 7.62a2.01 2.01 0 10-4.02 0 2.01 2.01 0 004.02 0zm-.001 11.682v-4.018H4.609v4.018h4.019zm7.752-3.93a2.01 2.01 0 110 4.019 2.01 2.01 0 010-4.02z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$2V(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M15.636 6.545V17a3.636 3.636 0 01-7.272 0V5.636a2.273 2.273 0 014.545 0v9.546a.91.91 0 11-1.818 0V6.545H9.727v8.637a2.273 2.273 0 104.546 0V5.636a3.636 3.636 0 10-7.273 0V17a5 5 0 0010 0V6.545h-1.364z"
  }));
}

function SvgComponent$2U(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16.27 6.654h-1.52c-.556 0-.93.115-1.124.346-.194.23-.291.577-.626 1.038V10h3.173l-.377 2.702H13V20h-3v-7.298H8V10h2V7.76c.37-1.193.706-2.117 1.378-2.774C12.05 4.329 12.944 4 14.062 4c.949 0 1.685.038 2.208.115v2.539z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$2T(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2h-8l-2-2z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$2S(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4 4h6l2 2h8c1.1 0 2 .9 2 2v10c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2l.01-12c0-1.1.89-2 1.99-2zm4 10a1 1 0 100-2 1 1 0 000 2zm5-1a1 1 0 11-2 0 1 1 0 012 0zm3 1a1 1 0 100-2 1 1 0 000 2z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$2R(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M20 18.016V8.032H3.968v9.984H20zm0-12c.544 0 1.008.2 1.392.6.384.4.576.872.576 1.416v9.984c0 .544-.192 1.016-.576 1.416-.384.4-.848.6-1.392.6H3.968a1.86 1.86 0 01-1.392-.6A1.977 1.977 0 012 18.016v-12C2 5.472 2.192 5 2.576 4.6c.384-.4.848-.6 1.392-.6h6l2.016 2.016H20z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$2Q(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M17 12V3a1 1 0 00-1-1H3a1 1 0 00-1 1v14l4-4h10a1 1 0 001-1zm4-6h-2v9H6v2a1 1 0 001 1h11l4 4V7a1 1 0 00-1-1z"
  }));
}

function SvgComponent$2P(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10 4l2 2h8a2 2 0 012 2v10a2 2 0 01-2 2H4a2 2 0 01-2-2V6c0-1.11.89-2 2-2h6zm5 5v3h-3v2h3v3h2v-3h3v-2h-3V9h-2z"
  }));
}

function SvgComponent$2O(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.579 16.09h5.526v1.637l3.158-2.454-3.158-2.455v1.636H6.58V4.636h9.474V3H6.579C5.707 3 5 3.733 5 4.636v9.819c0 .903.707 1.636 1.579 1.636zM18.42 7.91v11.454H9.737v-1.637h-1.58v1.637c0 .903.708 1.636 1.58 1.636h8.684c.872 0 1.579-.733 1.579-1.636V7.909c0-.904-.707-1.636-1.579-1.636H9.737c-.872 0-1.58.732-1.58 1.636v4.91h1.58v-4.91h8.684z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$2N(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6 2l17 10L6 22V2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 2h3v20H2z"
  }));
}

function SvgComponent$2M(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M19 2h3v20h-3z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M18 2L1 12l17 10V2z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$2L(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15 18v-2.016h-2.016V18H15zm-3.504 0v-2.016H9.528V18h1.968zm-3.48 0v-2.016H6V18h2.016zm10.968-5.016c.544 0 1.016.2 1.416.6.4.4.6.872.6 1.416v3.984c0 .544-.2 1.016-.6 1.416-.4.4-.872.6-1.416.6H5.016C4.472 21 4 20.8 3.6 20.4c-.4-.4-.6-.872-.6-1.416V15c0-.544.2-1.016.6-1.416.4-.4.872-.6 1.416-.6H15V9h2.016v3.984h1.968zm.336-6.288l-.792.792a3.357 3.357 0 00-1.2-.744 3.84 3.84 0 00-1.344-.24c-.992 0-1.816.328-2.472.984l-.816-.792a4.76 4.76 0 011.524-1.032 4.489 4.489 0 011.764-.36c.608 0 1.204.12 1.788.36.584.24 1.1.584 1.548 1.032zm.888-.792a6.67 6.67 0 00-2.004-1.248 5.988 5.988 0 00-2.22-.432c-.752 0-1.48.144-2.184.432a7.145 7.145 0 00-1.992 1.248l-.792-.792a7.208 7.208 0 012.316-1.572 6.821 6.821 0 015.292-.012A7.194 7.194 0 0121 5.112l-.792.792z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$2K(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M14.667 12.304l4.528 4.515L22 14.014V22h-7.999l2.85-2.84-4.523-4.521 2.34-2.335zM10.004 2l-2.85 2.845 4.523 4.516-2.344 2.34L4.81 7.186 2 9.99V2h8.004z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$2J(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12zm16.945.136c0-.443-.04-.869-.117-1.274l-5.71-.002v2.368h3.31c-.256 1.427-1.492 2.466-3.31 2.466-2.002 0-3.63-1.697-3.63-3.7S10.115 8.3 12.118 8.3c.904 0 1.711.312 2.349.919v.004l1.71-1.711c-1.05-.98-2.42-1.582-4.059-1.582a6.07 6.07 0 00-6.07 6.07 6.07 6.07 0 006.07 6.071c3.506 0 5.827-2.466 5.827-5.934z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$2I(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.277 1C6.049 1 1 6.05 1 12.278c0 4.983 3.23 9.21 7.713 10.702.564.103.742-.231.742-.53 0-.268.005-1.017 0-1.958-3.137.682-3.787-1.485-3.787-1.485-.513-1.303-1.251-1.65-1.251-1.65-1.024-.7.076-.686.076-.686 1.132.08 1.728 1.162 1.728 1.162 1.007 1.723 2.64 1.225 3.282.937.103-.729.395-1.226.717-1.508-2.505-.285-5.137-1.252-5.137-5.574 0-1.231.44-2.237 1.16-3.026-.116-.285-.504-1.432.111-2.985 0 0 .947-.303 3.1 1.157.9-.25 1.866-.375 2.824-.38.959.005 1.923.13 2.824.38 2.154-1.46 3.1-1.157 3.1-1.157.614 1.553.227 2.7.112 2.985.72.789 1.159 1.795 1.159 3.026 0 4.333-2.637 5.287-5.15 5.565.405.35.772 1.026.772 2.078v3.122c0 .302.182.635.755.526 4.478-1.494 7.705-5.72 7.705-10.7C23.555 6.048 18.506 1 12.277 1z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$2H(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M17.186 6.896L18.5 8.398V14h-.6a1.742 1.742 0 00-.437-1.24l-2.528-3.092a.25.25 0 00-.33-.372 835.27 835.27 0 00-1.885 1.966l-.006.007a1.838 1.838 0 01-2.786-.045 1.54 1.54 0 01.014-1.992l2.08-2.427A2.303 2.303 0 0113.772 6h1.439c.756 0 1.476.327 1.975.896zM2.75 7.5h1.5a.75.75 0 01.75.75v6.5a.75.75 0 01-.75.75h-1.5a.75.75 0 01-.75-.75v-6.5a.75.75 0 01.75-.75zm.125 6.5a.625.625 0 101.25 0 .625.625 0 00-1.25 0zM21.25 7.5h-1.5a.75.75 0 00-.75.75v6.5c0 .414.336.75.75.75h1.5a.75.75 0 00.75-.75v-6.5a.75.75 0 00-.75-.75zM19.875 14a.625.625 0 101.25 0 .625.625 0 00-1.25 0zm-2.869.886c.468-.435.557-1.28.074-1.805l-2.492-3.05-1.503 1.574a2.339 2.339 0 01-3.541-.06 2.038 2.038 0 01.018-2.638l1.987-2.318A1.915 1.915 0 0010.167 6h-1.17c-.592 0-1.16.236-1.58.655L5.5 8.235V14l2.946 3a3.12 3.12 0 002.268.962c.438 0 .925-.148 1.244-.467.84.29 1.652-.264 1.85-.926 1.095.08 1.815-.907 1.763-1.396.11.119.882.227 1.435-.287z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$2G(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z"
  }));
}

function SvgComponent$2F(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16.04 4.461c.31-.31.716-.461 1.137-.461.398 0 .796.151 1.106.461l2.258 2.25c.612.629.612 1.63 0 2.25l-4.628 4.62-4.492-4.492 4.62-4.628zM5.918 14.583l4.74-4.739 4.492 4.5-4.731 4.74c-.62.612-1.614.62-2.235.016l-.683.683H3l.98-.978c.654-.651 1.307-1.303 1.954-1.956-.636-.644-.636-1.646-.016-2.266z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$2E(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16 12V4h1V2H7v2h1v8l-2 2v2h5.2v6h1.6v-6H18v-2l-2-2z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$2D(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M18.984 20V8.984H5.016V20h13.968zm0-16.032c.544 0 1.016.2 1.416.6.4.4.6.872.6 1.416V20c0 .544-.2 1.008-.6 1.392-.4.384-.872.576-1.416.576H5.016c-.56 0-1.036-.192-1.428-.576A1.877 1.877 0 013 20V5.984c0-.544.196-1.016.588-1.416.392-.4.868-.6 1.428-.6H6V2h2.016v1.968h7.968V2H18v1.968h.984zM17.016 11v1.968H15V11h2.016zm-4.032 0v1.968h-1.968V11h1.968zM9 11v1.968H6.984V11H9z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$2C(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8h5z"
  }));
}

function SvgComponent$2B(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M9.429 15.47v-5.293H6L12 4l6 6.177h-3.429v5.294H9.43zM6 19v-1.765h12V19H6z"
  }));
}

function SvgComponent$2A(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.986 8.995V6.976h-1.972v2.02h1.972zm0 8.029v-6.01h-1.972v6.01h1.972zM12 2c1.827 0 3.518.457 5.072 1.37a9.478 9.478 0 013.558 3.558A9.834 9.834 0 0122 12a9.834 9.834 0 01-1.37 5.072 9.478 9.478 0 01-3.558 3.558A9.834 9.834 0 0112 22a9.834 9.834 0 01-5.072-1.37 9.657 9.657 0 01-3.558-3.582A9.791 9.791 0 012 12a9.79 9.79 0 011.37-5.048A9.842 9.842 0 016.952 3.37 9.79 9.79 0 0112 2z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$2z(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$2y(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M21 5c-1.11-.35-2.33-.5-3.5-.5-1.95 0-4.05.4-5.5 1.5-1.45-1.1-3.55-1.5-5.5-1.5-1.95 0-4.05.4-5.5 1.5v14.65c0 .25.25.5.5.5.1 0 .15-.05.25-.05C3.1 20.45 5.05 20 6.5 20c1.95 0 4.05.4 5.5 1.5 1.35-.85 3.8-1.5 5.5-1.5 1.65 0 3.35.3 4.75 1.05.1.05.15.05.25.05.25 0 .5-.25.5-.5V6c-.6-.45-1.25-.75-2-1zm0 13.5c-1.1-.35-2.3-.5-3.5-.5-1.7 0-4.15.65-5.5 1.5V8c1.35-.85 3.8-1.5 5.5-1.5 1.2 0 2.4.15 3.5.5v11.5z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$2x(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 11H19V7a2 2 0 00-2-2h-4V3.5a2.5 2.5 0 00-5 0V5H4a2 2 0 00-2 2v3.8h1.5c1.5 0 2.7 1.2 2.7 2.7 0 1.5-1.2 2.7-2.7 2.7H2V20a2 2 0 002 2h3.8v-1.5c0-1.5 1.2-2.7 2.7-2.7 1.5 0 2.7 1.2 2.7 2.7V22H17a2 2 0 002-2v-4h1.5a2.5 2.5 0 000-5z"
  }));
}

function SvgComponent$2w(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M0 0h24v24H0V0zm8.076 18.933l.004.006c.417.645.76 1.175 1.52 1.175.724 0 1.22-.305 1.22-1.41v-7.656h2.247v7.695c0 2.324-1.372 3.39-3.353 3.39-1.79 0-2.857-.952-3.39-2.057l1.752-1.143zm10.248 1.181c-1.105 0-1.715-.571-2.21-1.371l-1.828 1.105c.647 1.295 2.019 2.285 4.114 2.285 2.133 0 3.733-1.104 3.733-3.123 0-1.867-1.104-2.705-3.01-3.543l-.57-.229c-.953-.419-1.372-.686-1.372-1.371 0-.534.419-.953 1.067-.953.647 0 1.066.267 1.447.953l1.753-1.143c-.724-1.295-1.753-1.79-3.2-1.79-2.02 0-3.315 1.295-3.315 2.97 0 1.83 1.067 2.706 2.705 3.391l.571.229.018.007c1.018.453 1.62.72 1.62 1.479 0 .647-.57 1.104-1.523 1.104z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$2v(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M22.454 19.344L15.08 7.754a.443.443 0 01-.063-.216V3.51a.38.38 0 01.376-.372h.377a.38.38 0 00.377-.372V1.372A.38.38 0 0015.77 1H9.023a.38.38 0 00-.377.372v1.363a.38.38 0 00.377.372h.376a.38.38 0 01.377.372v4.028a.569.569 0 01-.063.217L2.37 19.344C1.366 20.924 2.527 23 4.41 23h16.005c1.883 0 3.044-2.076 2.04-3.656zm-1.38 1.642c-.095.155-.283.403-.66.403H4.41c-.408 0-.597-.248-.66-.403-.094-.155-.188-.434.032-.775l7.375-11.588c.22-.31.314-.682.314-1.085V3.51c0-.31-.063-.62-.189-.868h2.323a1.959 1.959 0 00-.189.868v4.028c0 .372.095.744.314 1.085l7.375 11.588c.157.341.063.62-.031.775z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15.613 15.006H9.211a.95.95 0 00-.816.433l-2.322 3.626c-.314.465.031 1.084.628 1.084h11.423c.565 0 .91-.62.627-1.084l-2.322-3.626a.99.99 0 00-.816-.433z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$2u(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M3 12h4v9H3z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M19.889 10.165H16.94c0-1.315.026-4.148-.176-5.393C16.48 3.02 15.864 3 15.119 3c-1.275 0-1.374 1.857-2.011 4.491-.571 2.36-3.305 4.173-5.108 4.528v8.666h3.204c1.275 0 .637 1.315 1.912 1.315h5.737C22.04 22 22 18.686 22 18.686v-6.31c0-1.29-.837-2.211-2.111-2.211z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$2t(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 3C9.31 3 7.41 4.22 7.41 4.22L6 9h12l-1.41-4.78S14.69 3 12 3zm0 8c-2.73 0-6.61.54-6.87.59-1.04.28-1.88.56-2.54.82C1.58 12.75 1 13 1 13h22s-.58-.25-1.59-.59c-.66-.26-1.52-.54-2.57-.82 0 0-4.02-.59-6.84-.59zm-8 6.5A3.5 3.5 0 017.5 14c1.47 0 2.73.9 3.25 2.19.32-.1.7-.19 1.25-.19s.93.09 1.25.19A3.498 3.498 0 0116.5 14a3.5 3.5 0 11-3.5 3.5c0-.16 0-.32.03-.47-.32-.07-.66-.12-1.03-.12-.37-.01-.71.05-1.03.12.03.15.03.31.03.47a3.5 3.5 0 11-7 0zM7.5 15a2.5 2.5 0 110 5 2.5 2.5 0 010-5zM19 17.5a2.5 2.5 0 10-5 0 2.5 2.5 0 005 0z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$2s(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.847 3.772a5.933 5.933 0 018.38 0 5.932 5.932 0 010 8.38L18.782 13.6c-.383.384-1.044.129-1.064-.413a7.186 7.186 0 00-.378-2.056.627.627 0 01.148-.647l.51-.51c1.093-1.093 1.127-2.872.045-3.976a2.81 2.81 0 00-3.99-.02l-2.619 2.62a2.806 2.806 0 00.403 4.304.625.625 0 01.271.491c.015.412-.13.837-.456 1.162l-.82.821a.626.626 0 01-.803.068 5.923 5.923 0 01-.8-9.05l2.62-2.621zm2.9 13.86a5.923 5.923 0 00-.814-9.036.626.626 0 00-.802.068l-.821.82c-.325.326-.472.75-.456 1.163.008.197.108.38.27.491a2.806 2.806 0 01.403 4.304l-2.619 2.62a2.81 2.81 0 01-3.99-.02c-1.081-1.104-1.047-2.883.046-3.975l.51-.51c.17-.17.225-.421.148-.648a7.183 7.183 0 01-.378-2.056c-.02-.542-.68-.797-1.064-.413l-1.447 1.447a5.932 5.932 0 000 8.38 5.933 5.933 0 008.38 0l2.62-2.62a.469.469 0 00.014-.014z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$2r(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M11.25 0H0v11.25h11.25V0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 0H12.75v11.25H24V0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 12.75h11.25V24H0V12.75z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.75 12.75H24V24H12.75V12.75zm1.5 1.5h8.25v8.25h-8.25v-8.25z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$2q(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M17.1 8.6V6.2c.6-.3 1.1-.9 1.1-1.6v-.1c0-1-.8-1.8-1.8-1.8h-.1c-1 0-1.8.8-1.8 1.8v.1c0 .7.4 1.3 1.1 1.6v2.4c-.9.1-1.8.5-2.5 1.1L6.5 4.6c.3-1.1-.4-2.3-1.5-2.5-1.1-.2-2.2.3-2.5 1.4-.3 1.1.4 2.3 1.5 2.6.5.1 1.1.1 1.6-.2l6.4 5c-1.2 1.8-1.2 4.1.1 5.9l-2 2c-.2 0-.3-.1-.5-.1-.9 0-1.7.8-1.7 1.7 0 .9.8 1.6 1.7 1.6.9 0 1.7-.8 1.7-1.7 0-.2 0-.3-.1-.5l1.9-1.9c2.3 1.7 5.6 1.3 7.3-1 1.7-2.3 1.3-5.6-1-7.3-.6-.5-1.4-.9-2.3-1zm-.8 7.8c-1.5 0-2.7-1.2-2.7-2.7 0-1.5 1.2-2.7 2.7-2.7 1.5 0 2.7 1.2 2.7 2.7 0 1.5-1.2 2.7-2.7 2.7z"
  }));
}

function SvgComponent$2p(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16.593 16.644v-1.136c0-.4-.18-.802-.493-1.047-.269-.223-.56-.423-.807-.601V12.5a.626.626 0 01-.291-.534v-1.404c0-.69.56-1.248 1.255-1.248h.313a1.25 1.25 0 011.255 1.248v1.404c0 .223-.112.4-.291.534v1.337c0 .023.022.045.044.067.202.09 1.12.557 1.994 1.27a.665.665 0 01.247.512v.958h-3.226zm-.583 0v-1.136a.827.827 0 00-.291-.624c-1.03-.846-2.128-1.381-2.352-1.492-.023-.023-.045-.045-.045-.067v-1.582a.74.74 0 00.336-.624V9.47c0-.824-.672-1.47-1.479-1.47h-.359c-.828 0-1.478.668-1.478 1.47v1.65c0 .267.135.49.336.623v1.582c0 .022-.022.044-.045.067-.224.111-1.321.668-2.352 1.492a.827.827 0 00-.291.624v1.136h8.02zm-8.603-1.136c0-.4.18-.802.493-1.047.269-.223.56-.423.807-.601V12.5a.626.626 0 00.291-.534v-1.404c0-.69-.56-1.248-1.255-1.248H7.43a1.25 1.25 0 00-1.255 1.248v1.404c0 .223.112.4.291.534v1.337c0 .023-.022.045-.044.067-.202.09-1.12.557-1.994 1.27a.665.665 0 00-.247.512v.958h3.226v-1.136zM23 16.644v-.757a.547.547 0 00-.202-.423c-.694-.58-1.456-.958-1.59-1.025-.023 0-.023-.023-.023-.045v-1.07a.506.506 0 00.224-.422v-1.114c0-.558-.448-1.003-1.008-1.003h-.224c-.56 0-1.008.445-1.008 1.002v1.114c0 .179.09.335.224.424v.958c.202.133.403.29.583.445.29.245.47.602.47.98v.959H23v-.023zM2.792 14.417a7.869 7.869 0 00-1.59 1.024.548.548 0 00-.202.424v.757h2.599v-.958c0-.379.179-.735.47-.98.202-.156.404-.312.583-.446v-.958a.506.506 0 00.224-.423v-1.114c0-.557-.448-1.003-1.008-1.003h-.224c-.56 0-1.009.446-1.009 1.003v1.114c0 .178.09.334.224.423v1.07c-.044.044-.044.066-.067.066z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$2o(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M17.333 20.126V10.57H5.904v9.555h11.429zm0-11.429c.518 0 .967.183 1.348.549.381.365.572.807.572 1.325v9.555c0 .518-.19.96-.572 1.325-.38.366-.83.549-1.348.549H5.904c-.518 0-.968-.183-1.349-.549a1.77 1.77 0 01-.571-1.325V10.57c0-.518.19-.96.571-1.325.381-.366.83-.549 1.349-.549h8.663v-1.92c0-.518-.133-1.006-.4-1.463A2.968 2.968 0 0013.08 4.23a2.857 2.857 0 00-1.463-.4c-.518 0-1.005.133-1.463.4A2.968 2.968 0 009.07 5.314c-.267.457-.4.945-.4 1.463H6.84c0-.868.213-1.668.64-2.4A4.749 4.749 0 019.218 2.64a4.678 4.678 0 012.4-.64c.869 0 1.669.213 2.4.64a4.748 4.748 0 011.737 1.737c.427.732.64 1.532.64 2.4v1.92h.938zm-5.715 8.572c-.518 0-.967-.19-1.348-.572-.381-.38-.572-.83-.572-1.348 0-.518.19-.968.572-1.349.38-.381.83-.571 1.348-.571.518 0 .968.19 1.349.571.38.381.571.83.571 1.349 0 .518-.19.967-.571 1.348-.381.381-.83.572-1.349.572z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$2n(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15.09 8.032V6.016c0-.544-.14-1.056-.42-1.536-.279-.48-.658-.86-1.137-1.14-.48-.28-.99-.42-1.533-.42-.543 0-1.054.14-1.533.42-.479.28-.858.66-1.138 1.14-.28.48-.419.992-.419 1.536v2.016h6.18zm-3.09 9c.543 0 1.014-.2 1.413-.6.4-.4.599-.872.599-1.416 0-.544-.2-1.016-.599-1.416-.399-.4-.87-.6-1.413-.6s-1.014.2-1.413.6c-.4.4-.599.872-.599 1.416 0 .544.2 1.016.599 1.416.399.4.87.6 1.413.6zm5.988-9c.543 0 1.014.192 1.413.576.4.384.599.848.599 1.392v10.032c0 .544-.2 1.008-.599 1.392-.399.384-.87.576-1.413.576H6.012a1.97 1.97 0 01-1.413-.576A1.86 1.86 0 014 20.032V10c0-.544.2-1.008.599-1.392.399-.384.87-.576 1.413-.576h.982V6.016c0-.912.224-1.752.67-2.52a4.981 4.981 0 011.821-1.824A4.895 4.895 0 0112 1c.91 0 1.748.224 2.515.672a4.981 4.981 0 011.82 1.824 4.92 4.92 0 01.671 2.52v2.016h.982z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$2m(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M20 5.778C20 4.796 19.204 4 18.222 4H5.778C4.79 4 4 4.791 4 5.778v12.444C4 19.2 4.791 20 5.778 20h12.444c.982 0 1.778-.796 1.778-1.778v-4.15l-1.778 1.777v2.373H5.778V5.778h12.444V8.15L20 9.93V5.778zm-3.849 7.11l-2.302 2.303 1.262 1.253L19.556 12 15.11 7.556 13.85 8.809l2.302 2.302H7.556v1.778h8.595z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$2l(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.6 5.333L2 2v20l5.6-3.333V22L22 12 7.6 2v3.333z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$2k(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M9 2a7 7 0 017 7c0 1.57-.5 3-1.39 4.19l.8.81H16l6 6-2 2-6-6v-.59l-.81-.8A6.916 6.916 0 019 16 7 7 0 119 2zM8 5v3H5v2h3v3h2v-3h3V8h-3V5H8z"
  }));
}

function SvgComponent$2j(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.272 2.6L21 19.328 19.728 20.6l-4.176-4.176c-.656.416-1.512.712-2.568.888V20.6h-1.968v-3.288a6.836 6.836 0 01-3.012-1.164 6.967 6.967 0 01-2.172-2.364 6.49 6.49 0 01-.816-3.168h1.68c0 .976.256 1.856.768 2.64a5.103 5.103 0 001.932 1.776 5.44 5.44 0 004.908.12l-1.656-1.632c-.224.064-.44.096-.648.096a2.894 2.894 0 01-1.488-.408 3.043 3.043 0 01-1.104-1.104A2.894 2.894 0 019 10.616v-.744l-6-6L4.272 2.6zM15 10.76L9 4.808v-.192c0-.528.136-1.024.408-1.488.272-.464.64-.832 1.104-1.104.464-.272.96-.408 1.488-.408s1.024.136 1.488.408c.464.272.832.64 1.104 1.104.272.464.408.96.408 1.488v6.144zm3.984-.144c0 1.136-.296 2.232-.888 3.288l-1.224-1.272a4.65 4.65 0 00.432-2.016h1.68z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$2i(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M9 2a7 7 0 017 7c0 1.57-.5 3-1.39 4.19l.8.81H16l6 6-2 2-6-6v-.59l-.81-.8A6.916 6.916 0 019 16 7 7 0 119 2zM5 8v2h8V8H5z"
  }));
}

function SvgComponent$2h(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M17 13H7v-2h10v2zM12 2a10 10 0 100 20 10 10 0 000-20z"
  }));
}

function SvgComponent$2g(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M17.304 10.616h1.68a6.49 6.49 0 01-.816 3.168 6.967 6.967 0 01-2.172 2.364 6.836 6.836 0 01-3.012 1.164V20.6h-1.968v-3.288a6.836 6.836 0 01-3.012-1.164 6.967 6.967 0 01-2.172-2.364 6.49 6.49 0 01-.816-3.168h1.68c0 .976.256 1.856.768 2.64a5.103 5.103 0 001.932 1.776A5.44 5.44 0 0012 15.68a5.44 5.44 0 002.604-.648 5.103 5.103 0 001.932-1.776c.512-.784.768-1.664.768-2.64zm-5.304 3a2.894 2.894 0 01-1.488-.408 3.043 3.043 0 01-1.104-1.104A2.894 2.894 0 019 10.616v-6c0-.528.136-1.024.408-1.488.272-.464.64-.832 1.104-1.104.464-.272.96-.408 1.488-.408s1.024.136 1.488.408c.464.272.832.64 1.104 1.104.272.464.408.96.408 1.488v6c0 .528-.136 1.024-.408 1.488-.272.464-.64.832-1.104 1.104-.464.272-.96.408-1.488.408z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$2f(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M17.333 20.126V10.57H5.904v9.555h11.429zM8.67 6.777v1.92h5.897v-1.92c0-.518-.133-1.006-.4-1.463A2.968 2.968 0 0013.08 4.23a2.857 2.857 0 00-1.463-.4c-.518 0-1.005.133-1.463.4-.457.266-.819.628-1.085 1.085-.267.457-.4.945-.4 1.463zm8.663 1.92c.518 0 .967.183 1.348.549.381.365.572.807.572 1.325v9.555c0 .518-.19.96-.572 1.325-.38.366-.83.549-1.348.549H5.904c-.518 0-.968-.183-1.349-.549a1.77 1.77 0 01-.571-1.325V10.57c0-.518.19-.96.571-1.325.381-.366.83-.549 1.349-.549h.937v-1.92c0-.868.213-1.668.64-2.4A4.749 4.749 0 019.218 2.64a4.678 4.678 0 012.4-.64c.869 0 1.669.213 2.4.64a4.748 4.748 0 011.737 1.737c.427.732.64 1.532.64 2.4v1.92h.938zm-5.715 8.572c-.518 0-.967-.19-1.348-.572-.381-.38-.572-.83-.572-1.348 0-.518.19-.968.572-1.349.38-.381.83-.571 1.348-.571.518 0 .968.19 1.349.571.38.381.571.83.571 1.349 0 .518-.19.967-.571 1.348-.381.381-.83.572-1.349.572z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$2e(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M17.256 17.6V3.584H6.744V17.6h10.512zm-3.24 3v-.984H9.984v.984h4.032zM15.984.584c.528 0 1.024.136 1.488.408.464.272.832.64 1.104 1.104.272.464.408.96.408 1.488v16.032c0 .528-.136 1.024-.408 1.488-.272.464-.64.832-1.104 1.104-.464.272-.96.408-1.488.408H8.016a2.894 2.894 0 01-1.488-.408 3.043 3.043 0 01-1.104-1.104 2.894 2.894 0 01-.408-1.488V3.584c0-.528.136-1.024.408-1.488.272-.464.64-.832 1.104-1.104.464-.272.96-.408 1.488-.408h7.968z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$2d(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 10c.543 0 1.014.198 1.413.595.4.397.599.865.599 1.405s-.2 1.008-.599 1.405c-.399.397-.87.595-1.413.595a1.939 1.939 0 01-1.413-.595c-.4-.397-.599-.865-.599-1.405s.2-1.008.599-1.405c.399-.397.87-.595 1.413-.595zm5.988 0c.543 0 1.014.198 1.413.595.4.397.599.865.599 1.405s-.2 1.008-.599 1.405c-.399.397-.87.595-1.413.595a1.938 1.938 0 01-1.413-.595c-.4-.397-.599-.865-.599-1.405s.2-1.008.599-1.405c.4-.397.87-.595 1.413-.595zM6.012 10c.543 0 1.014.198 1.413.595.4.397.599.865.599 1.405s-.2 1.008-.599 1.405c-.399.397-.87.595-1.413.595a1.938 1.938 0 01-1.413-.595C4.199 13.008 4 12.54 4 12s.2-1.008.599-1.405c.399-.397.87-.595 1.413-.595z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$2c(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.808 10.52c.928.24 1.672.496 2.232.768.768.368 1.352.808 1.752 1.32.48.624.72 1.384.72 2.28 0 .976-.344 1.776-1.032 2.4-.608.56-1.44.944-2.496 1.152v2.16h-3v-2.16c-1.024-.224-1.856-.64-2.496-1.248-.704-.672-1.088-1.536-1.152-2.592h2.208c.032.64.272 1.136.72 1.488.512.416 1.256.624 2.232.624.976 0 1.704-.208 2.184-.624.352-.32.528-.704.528-1.152 0-.544-.192-.992-.576-1.344-.48-.464-1.288-.832-2.424-1.104-1.504-.352-2.632-.832-3.384-1.44-.864-.704-1.296-1.6-1.296-2.688 0-.928.336-1.72 1.008-2.376.624-.608 1.44-1.016 2.448-1.224V2.6h3v2.208c1.024.24 1.824.72 2.4 1.44.528.672.808 1.456.84 2.352h-2.208c-.048-1.408-.888-2.112-2.52-2.112-.832 0-1.488.172-1.968.516-.48.344-.72.796-.72 1.356 0 .48.224.888.672 1.224.448.336 1.224.648 2.328.936z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$2b(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$2a(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.5 14.929c.405 0 .756.148 1.054.446.297.298.446.649.446 1.054 0 .404-.149.756-.446 1.053a1.44 1.44 0 01-1.054.447 1.44 1.44 0 01-1.054-.447A1.44 1.44 0 0111 16.43c0-.405.149-.756.446-1.054a1.44 1.44 0 011.054-.446zm0-4.465c.405 0 .756.15 1.054.447.297.297.446.649.446 1.053 0 .405-.149.756-.446 1.054a1.44 1.44 0 01-1.054.446 1.44 1.44 0 01-1.054-.446A1.441 1.441 0 0111 11.964c0-.405.149-.756.446-1.053a1.44 1.44 0 011.054-.447zM12.5 9a1.44 1.44 0 01-1.054-.446A1.441 1.441 0 0111 7.5c0-.405.149-.756.446-1.054A1.44 1.44 0 0112.5 6c.405 0 .756.149 1.054.446.297.298.446.65.446 1.054 0 .405-.149.756-.446 1.054A1.44 1.44 0 0112.5 9z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$29(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M18 4l2 4h-3l-2-4h-2l2 4h-3l-2-4H8l2 4H7L5 4H4a2 2 0 00-2 2v12a2 2 0 002 2h16a2 2 0 002-2V4h-4z"
  }));
}

function SvgComponent$28(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M19 3a2 2 0 012 2v14a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h14zm-3 6h-3v5.5a2.5 2.5 0 11-1-2V7h4v2zM5 19V5h14v14H5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "a",
    style: {
      maskType: "alpha"
    },
    width: 18,
    height: 18,
    x: 3,
    y: 3,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M19 3a2 2 0 012 2v14a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h14zm-3 6h-3v5.5a2.5 2.5 0 11-1-2V7h4v2zM5 19V5h14v14H5z",
    clipRule: "evenodd"
  })));
}

function SvgComponent$27(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M18.227 4v1.77h-1.773V4H7.546v1.77H5.773V4H4v16h1.773v-1.77h1.773V20h8.908v-1.77h1.773V20H20V4h-1.773zm0 10.667v1.77h-1.773v-1.77h1.773zm-10.68 0v1.77H5.772v-1.77h1.773zm10.68-3.563v1.77h-1.773v-1.77h1.773zm-10.68 0v1.77H5.772v-1.77h1.773zm10.68-3.541v1.77h-1.773v-1.77h1.773zm-10.68 0v1.77H5.772v-1.77h1.773z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$26(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$25(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10 2h1v20h-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 2h1v20h-1z"
  }));
}

function SvgComponent$24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M19.143 20.182l-2.234-2.234H4.546v-.818l1.637-1.636v-4.91c0-.932.237-1.857.679-2.683L3 4.039 4.047 3l16.135 16.143-1.04 1.039zm-1.506-5.67v-3.928a5.72 5.72 0 00-4.09-5.49v-.237a1.636 1.636 0 00-3.273 0v.238c-.5.147-.982.368-1.424.654l8.787 8.763zm-4.09 4.254a1.636 1.636 0 01-3.273 0h3.272z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$23(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15.984 10.616L9 14.6V6.584l6.984 4.032zm5.016 6v-12H3v12h18zM21 2.6c.544 0 1.016.196 1.416.588.4.392.6.868.6 1.428l-.048 12c0 .544-.192 1.008-.576 1.392a1.896 1.896 0 01-1.392.576h-5.016V20.6H8.016v-2.016H3c-.56 0-1.036-.192-1.428-.576a1.877 1.877 0 01-.588-1.392v-12c0-.56.196-1.036.588-1.428A1.944 1.944 0 013 2.6h18z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$22(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M21.245 1H2.615C1.723 1 1 1.706 1 2.576v18.848C1 22.294 1.723 23 2.615 23h18.63c.893 0 1.617-.706 1.617-1.576V2.576c0-.87-.724-1.576-1.617-1.576zM7.626 19.417H4.324V9.483h3.302v9.934zM5.976 8.126h-.022c-1.108 0-1.825-.763-1.825-1.716 0-.975.74-1.717 1.868-1.717 1.13 0 1.825.742 1.847 1.717 0 .953-.717 1.716-1.868 1.716zm13.557 11.29h-3.302v-5.315c0-1.335-.478-2.246-1.672-2.246-.912 0-1.455.614-1.695 1.208-.087.212-.108.508-.108.805v5.548H9.454s.043-9.003 0-9.934h3.302v1.407c.439-.677 1.223-1.641 2.976-1.641 2.172 0 3.802 1.42 3.802 4.472v5.697z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$21(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16 1H3v22h18V5.993L16.007 1H16zm4 21H4V2h11v5h5v15zM16 2.407V6h3.593L16 2.407z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.938 10a1.5 1.5 0 00-1.131.504c-.251.292-.37.646-.37.996 0 .488.218.846.445 1.218l.053.089.26.423.168.274a25.166 25.166 0 01-.826 2.144l-.082.02c-.312.072-.666.155-1.014.28-.338.12-.677.286-.96.568-.284.281-.481.705-.481 1.172 0 .31.103.622.328.878.226.257.589.434.985.434.853 0 1.464-.597 1.863-1.19.268-.398.46-.81.592-1.177.57-.186 1.209-.367 1.775-.51.489.457 1.102 1.002 1.957 1.002.917 0 1.5-.73 1.5-1.389 0-.34-.119-.693-.38-.972-.263-.28-.668-.451-1.12-.451-.527 0-1.01.173-1.453.351a14.742 14.742 0 01-1.137-1.447l.14-.346.071-.176.023-.056c.152-.375.293-.723.293-1.139a1.498 1.498 0 00-1.5-1.5zm0 1.125c.175 0 .221.042.28.117.06.075.095.214.095.258 0 .077-.085.403-.235.773l-.026.07-.032.083-.08-.132-.043-.073a3.344 3.344 0 01-.335-.721c0-.066.038-.191.1-.264.062-.072.12-.111.275-.111zm1.037 3.996a12.08 12.08 0 01-.686-.873c-.141.406-.286.76-.45 1.165l-.013.03c.403-.124.755-.22 1.149-.322zm2.525.316c.195 0 .254.046.299.094a.307.307 0 01.076.205v.006c0 .072.001.258-.375.258-.178 0-.451-.16-.75-.375.312-.109.579-.188.75-.188zm-5.138 1.528l.058-.115-.091.02c-.178.042-.356.084-.507.138-.253.09-.446.201-.55.305-.105.103-.147.18-.147.375a.223.223 0 00.053.142c.02.024.038.045.134.045.311 0 .637-.253.932-.691.046-.069.082-.143.118-.219z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$20(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M20 6v12a2 2 0 01-2 2H6a2 2 0 01-2-2V6a2 2 0 012-2h12a2 2 0 012 2zM8 11.5H7v-1h1v1zm5-1h-1v3h1v-3zM8 9a1.5 1.5 0 011.5 1.5v1A1.5 1.5 0 018 13H7v2H5.5V9H8zm6.5 1.5A1.5 1.5 0 0013 9h-2.5v6H13a1.5 1.5 0 001.5-1.5v-3zm1-1.5h3v1.5H17v1h1.5V13H17v2h-1.5V9z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "a",
    style: {
      maskType: "alpha"
    },
    width: 16,
    height: 16,
    x: 4,
    y: 4,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M20 6v12a2 2 0 01-2 2H6a2 2 0 01-2-2V6a2 2 0 012-2h12a2 2 0 012 2zM8 11.5H7v-1h1v1zm5-1h-1v3h1v-3zM8 9a1.5 1.5 0 011.5 1.5v1A1.5 1.5 0 018 13H7v2H5.5V9H8zm6.5 1.5A1.5 1.5 0 0013 9h-2.5v6H13a1.5 1.5 0 001.5-1.5v-3zm1-1.5h3v1.5H17v1h1.5V13H17v2h-1.5V9z",
    clipRule: "evenodd"
  })));
}

function SvgComponent$1$(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 13.68c.827 0 1.733.12 2.72.36 1.12.28 2.027.653 2.72 1.12.827.547 1.24 1.16 1.24 1.84v1.68H5.32V17c0-.68.413-1.293 1.24-1.84.693-.467 1.6-.84 2.72-1.12.987-.24 1.893-.36 2.72-.36zM12 12a3.2 3.2 0 01-1.66-.45c-.507-.3-.91-.703-1.21-1.21-.3-.507-.45-1.06-.45-1.66 0-.6.15-1.16.45-1.68.3-.52.703-.93 1.21-1.23A3.2 3.2 0 0112 5.32c.6 0 1.153.15 1.66.45.507.3.91.71 1.21 1.23.3.52.45 1.08.45 1.68 0 .6-.15 1.153-.45 1.66-.3.507-.703.91-1.21 1.21A3.2 3.2 0 0112 12z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$1_(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.371 7.227V4.575S7.411 1 12.151 1c4.741 0 4.781 3.816 4.54 6.227.643-.04 1.125 1.808-.803 4.057 0 0-.16 1.447-1.125 2.25 1.044.763 4.78 1.969 5.785 2.852.12.08.24.201.321.282.924.723 2.13 2.45 2.13 5.142 0 .321-.161.602-.442.803-.884.523-3.255 1.125-10.606 1.326-7.914.04-10.847-1.165-10.847-1.768-.321-.361.04-3.575 1.968-5.503.121-.12.241-.201.402-.322C5.121 15.262 6.85 14.9 9.34 13.574c0 0-1.165-1.245-1.044-2.17-.763-.562-2.17-3.454-.924-4.177z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$1Z(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8 5v14l11-7L8 5z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$1Y(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.18 18.68h11.64v1.64H6.18v-1.64zm4.14-10c0 .453.167.84.5 1.16.333.32.73.48 1.19.48.46 0 .853-.16 1.18-.48.327-.32.49-.707.49-1.16 0-.453-.167-.847-.5-1.18A1.614 1.614 0 0012 7c-.453 0-.847.167-1.18.5-.333.333-.5.727-.5 1.18zm6.68 0c0 .693-.173 1.487-.52 2.38-.293.76-.707 1.58-1.24 2.46-.427.693-.92 1.413-1.48 2.16-.4.533-.813 1.047-1.24 1.54l-.52.6-.52-.6a28.447 28.447 0 01-1.24-1.54 28.615 28.615 0 01-1.48-2.16c-.533-.88-.947-1.7-1.24-2.46C7.173 10.167 7 9.373 7 8.68c0-.907.223-1.743.67-2.51a4.964 4.964 0 011.82-1.82A4.898 4.898 0 0112 3.68c.907 0 1.743.223 2.51.67a4.964 4.964 0 011.82 1.82c.447.767.67 1.603.67 2.51z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$1X(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4 2l16.364 9.73L4 22V2z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$1W(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M14.53 11.987a1.571 1.571 0 011.427-1.28 1.565 1.565 0 011.653 1.744v.114c-.327 1.849-2.07 3.12-3.918 2.865a4.281 4.281 0 01-1.155-.362c1.051-.653 1.812-1.744 1.993-3.012v-.069z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 9.6l4.8 3.2L8 16V9.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M23.338 4.196c.143-.102.29-.172.408-.192a.32.32 0 01.102 0 .165.165 0 01.102.045c.108.11.034.358-.148.612L20.8 8.696V20H0V6.4h20.333l3.005-2.204zM17.606 8.4H2V18h16.8v-6.834a2.731 2.731 0 01-.25.165l-.035.011a3.187 3.187 0 00-.362-.702 2.772 2.772 0 00-1.642-.985l.125-.238c.145-.254.426-.623.68-.804l.29-.213z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$1V(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M19 4H4.6C3.712 4 3 4.712 3 5.6v9.6c0 .88.712 1.6 1.6 1.6h4v1.6H15v-1.6h1.6v-1.6h-12V5.6H19V12h1.6V5.6A1.6 1.6 0 0019 4zm-6.4 5.6V7.2H11v2.4H8.6v1.6H11v2.4h1.6v-2.4H15V9.6h-2.4zm5.2 10l3.6-3.6-3.6-3.6-1.2 1.2L19 16l-2.4 2.4 1.2 1.2z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$1U(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12 20c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-18a10 10 0 100 20 10 10 0 000-20zm1 5h-2v4H7v2h4v4h2v-4h4v-2h-4V7z"
  }));
}

function SvgComponent$1T(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"
  }));
}

function SvgComponent$1S(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3 19V5l18-.007V19H3zm1-1h16V6H4v12z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3 19.034h18V5H3v14.034zM3.61 5.61h16.78V17.54l-4.882-3.448-3.02 1.8-4.912-4.911-3.966 3.966V5.61zm.214 9.976l-.214-.213v3.05h16.78v-.152l-4.882-3.447-3.111 1.83-4.82-4.82-3.753 3.752z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$1R(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M17 17h-2v-4h2v4zm-4 0h-2V7h2v10zm-4 0H7v-7h2v7zM19 3H5c-1.11 0-2 .89-2 2v14a2 2 0 002 2h14a2 2 0 002-2V5a2 2 0 00-2-2z"
  }));
}

function SvgComponent$1Q(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3.25 22C2.56 22 2 21.44 2 20.75V3.25C2 2.56 2.56 2 3.25 2h8.125c.346 0 .625.28.625.625v1.25c0 .346-.28.625-.625.625H4.5v15h15v-6.875c0-.346.28-.625.625-.625h1.25c.346 0 .625.28.625.625v8.125c0 .69-.56 1.25-1.25 1.25H3.25z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M21.375 2.001h-6.25a.623.623 0 00-.442 1.067l2.241 2.241-6.25 6.25a.624.624 0 000 .884l.884.884c.246.244.64.244.885 0l6.25-6.25 2.24 2.241A.625.625 0 0022 8.876v-6.25a.624.624 0 00-.625-.625z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$1P(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z"
  }));
}

function SvgComponent$1O(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2 2h5v5H2V2zm7.5 0h5v5h-5V2zM22 2h-5v5h5V2zM2 9.5h5v5H2v-5zm12.5 0h-5v5h5v-5zm2.5 0h5v5h-5v-5zM7 17H2v5h5v-5zm2.5 0h5v5h-5v-5zM22 17h-5v5h5v-5z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$1N(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4 5.6h6.4a1.6 1.6 0 113.2 0H20v1.6h-.8V16h-4.6l1.4 4.8h-1.6L13 16h-2l-1.4 4.8H8L9.4 16H4.8V7.2H4V5.6zm2.4 1.6v7.2h11.2V7.2H6.4zm5.2 5.6a.393.393 0 00.28-.12L13 11.568c.256-.256.512-.512.512-.768s-.256-.512-.512-.768L11.88 8.92a.393.393 0 00-.28-.12.4.4 0 00-.4.4v3.2c0 .22.18.4.4.4z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "a",
    style: {
      maskType: "alpha"
    },
    width: 16,
    height: 17,
    x: 4,
    y: 4,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4 5.6h6.4a1.6 1.6 0 113.2 0H20v1.6h-.8V16h-4.6l1.4 4.8h-1.6L13 16h-2l-1.4 4.8H8L9.4 16H4.8V7.2H4V5.6zm2.4 1.6v7.2h11.2V7.2H6.4zm5.2 5.6a.393.393 0 00.28-.12L13 11.568c.256-.256.512-.512.512-.768s-.256-.512-.512-.768L11.88 8.92a.393.393 0 00-.28-.12.4.4 0 00-.4.4v3.2c0 .22.18.4.4.4z",
    clipRule: "evenodd"
  })));
}

function SvgComponent$1M(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M19 1l-1.26 2.75L15 5l2.74 1.26L19 9l1.25-2.74L23 5l-2.75-1.25L19 1zM9 4L6.5 9.5 1 12l5.5 2.5L9 20l2.5-5.5L17 12l-5.5-2.5L9 4zm10 11l-1.26 2.74L15 19l2.74 1.25L19 23l1.25-2.75L23 19l-2.75-1.26"
  }));
}

function SvgComponent$1L(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9.5 12.82c0-.44.113-.853.34-1.24.227-.387.533-.693.92-.92.387-.227.8-.34 1.24-.34.44 0 .853.113 1.24.34.387.227.693.533.92.92.227.387.34.8.34 1.24 0 .44-.113.853-.34 1.24a2.537 2.537 0 01-.92.92c-.387.227-.8.34-1.24.34-.44 0-.853-.113-1.24-.34a2.537 2.537 0 01-.92-.92c-.227-.387-.34-.8-.34-1.24zm9.18 5.5l-3.2-3.2c.467-.733.7-1.5.7-2.3 0-.747-.187-1.44-.56-2.08A4.151 4.151 0 0012 8.68a4.15 4.15 0 00-3.62 2.06 4.075 4.075 0 00-.56 2.09c0 .753.187 1.45.56 2.09.373.64.88 1.147 1.52 1.52s1.34.56 2.1.56c.8 0 1.567-.233 2.3-.7l3.68 3.7c-.293.213-.62.32-.98.32H7c-.453 0-.847-.16-1.18-.48a1.55 1.55 0 01-.5-1.16l.04-13.36c0-.453.16-.84.48-1.16.32-.32.707-.48 1.16-.48h6.68l5 5v9.64z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$1K(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15.64 13.68h2.8c.16-.72.24-1.28.24-1.68 0-.4-.08-.96-.24-1.68h-2.8c.08.533.12 1.09.12 1.67 0 .58-.04 1.143-.12 1.69zm-1.5 4.6a6.52 6.52 0 002.09-1.16 6.74 6.74 0 001.55-1.8h-2.46a12.824 12.824 0 01-1.18 2.96zm-.18-4.6c.08-.547.12-1.11.12-1.69 0-.58-.04-1.137-.12-1.67h-3.92c-.067.453-.1 1.013-.1 1.68s.033 1.227.1 1.68h3.92zM12 18.64c.76-1.107 1.293-2.213 1.6-3.32h-3.2c.347 1.16.88 2.267 1.6 3.32zM8.68 8.68A12.52 12.52 0 019.86 5.7c-.76.253-1.46.643-2.1 1.17a6.494 6.494 0 00-1.54 1.81h2.46zm-2.46 6.64c.4.68.917 1.28 1.55 1.8a6.52 6.52 0 002.09 1.16 12.825 12.825 0 01-1.18-2.96H6.22zm-.66-1.64h2.8c-.067-.6-.1-1.16-.1-1.68s.033-1.08.1-1.68h-2.8c-.16.72-.24 1.28-.24 1.68 0 .4.08.96.24 1.68zM12 5.36a11.903 11.903 0 00-1.6 3.32h3.2c-.307-1.107-.84-2.213-1.6-3.32zm5.78 3.32a6.494 6.494 0 00-1.54-1.81 6.537 6.537 0 00-2.1-1.17c.507.907.9 1.9 1.18 2.98h2.46zm-5.78-5c1.52 0 2.927.38 4.22 1.14a7.886 7.886 0 012.96 2.96A8.182 8.182 0 0120.32 12c0 1.52-.38 2.927-1.14 4.22a7.886 7.886 0 01-2.96 2.96A8.182 8.182 0 0112 20.32c-1.52 0-2.927-.38-4.22-1.14a8.036 8.036 0 01-2.96-2.98A8.146 8.146 0 013.68 12c0-1.507.38-2.907 1.14-4.2A8.188 8.188 0 017.8 4.82 8.146 8.146 0 0112 3.68z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$1J(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6-1.41-1.41z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$1I(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M15.41 16.58L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.42z"
  }));
}

function SvgComponent$1H(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M4 2h7v20H4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 2h7v20h-7z"
  }));
}

function SvgComponent$1G(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6 1.41 1.41z"
  }));
}

function SvgComponent$1F(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M18.968 10.488h-3v.984h2.016v1.512h-2.016V15H14.48V9h4.488v1.488zM8.984 9c.288 0 .524.096.708.288a.97.97 0 01.276.696v.504H6.512v3H8.48V12h1.488v2.016a.982.982 0 01-.276.684c-.184.2-.42.3-.708.3h-3a.919.919 0 01-.708-.3.982.982 0 01-.276-.684V9.984a.97.97 0 01.276-.696A.937.937 0 015.984 9h3zm2.496 0h1.488v6H11.48V9z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$1E(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M20.794 6.133a.79.79 0 011.067.179c.088.12.137.261.139.407v11.55c0 .403-.343.73-.766.73H2.628V19h-.001a.782.782 0 01-.453-.142l1.855-1.525 16.765-11.2zM2 18.688V6.76a.769.769 0 011.213-.62L11 11.602l-6.971 5.73L2 18.688zm0 0zm0 0a.754.754 0 00.174.17L2 19v-.311z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$1D(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M20.235 18.97H4.165a1.151 1.151 0 01-1.147-1.147V6.213c0-.623.508-1.147 1.148-1.147h16.07c.623 0 1.147.508 1.147 1.147v11.61a1.14 1.14 0 01-1.148 1.148z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.314 18.97l6.87-5.525.05-.295-7.084-5.1-.017 10.675.18.246z",
    clipRule: "evenodd",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.166 18.97a1.14 1.14 0 01-1.148-1.147V6.197c0-.64.508-.754 1.148-.754.64 0 1.148.13 1.148.754v12.774H4.166z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3.018 6.197c0-.623.508-.754 1.148-.754.64 0 1.148.115 1.148.754v12.774H4.166a1.14 1.14 0 01-1.148-1.148V6.197zm2.132 0c0-.344-.164-.59-.984-.59s-.984.23-.984.59v11.626c0 .541.443.984.984.984h.984V6.197z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M20.235 18.97h-1.147V6.165c0-.64.508-.721 1.147-.721.64 0 1.148.082 1.148.721V17.84c0 .623-.508 1.132-1.148 1.132z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M19.088 6.164c0-.64.508-.721 1.147-.721.64 0 1.148.082 1.148.721V17.84a1.14 1.14 0 01-1.148 1.148h-1.147V6.164zm2.131 0c0-.41-.246-.557-.984-.557-.737 0-.983.13-.983.557v12.66h.983a.987.987 0 00.984-.985V6.164z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15.316 18.97L3.114 6.675l.642.26 8.494 6.117 9.133-6.697v11.485c0 .623-.508 1.132-1.148 1.132h-4.919z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.184 13.445L3.51 7.148c-.508-.377-.656-1.099-.279-1.607a1.19 1.19 0 011.64-.246l7.33 5.33 7.378-5.395a1.14 1.14 0 011.607.262 1.14 1.14 0 01-.262 1.607l-8.74 6.346z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M19.563 5.213A1.13 1.13 0 0120.235 5c.361 0 .706.164.935.492.36.525.246 1.23-.262 1.607l-8.724 6.362L3.51 7.148c-.508-.377-.656-1.099-.295-1.607.23-.311.59-.475.95-.475.247 0 .493.065.69.213l7.33 5.329 7.378-5.395zm1.476.36a1.002 1.002 0 00-.804-.409c-.213 0-.41.066-.59.18l-7.362 5.395-.099.066-.098-.066-7.314-5.313a.948.948 0 00-.59-.196c-.328 0-.64.164-.82.41-.311.426-.196 1.049.246 1.377l8.576 6.231 8.642-6.297c.426-.328.524-.934.213-1.377z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16_107",
    x1: 3.115,
    x2: 21.389,
    y1: 18.972,
    y2: 18.972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.2
  }))));
}

function SvgComponent$1C(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16.68 6.236v2.372h-.005l.03.004a5.206 5.206 0 11-3.985 9.277l-1.93 1.93c.05.158.076.32.078.485a1.694 1.694 0 11-1.694-1.694h.002c.164.002.327.029.483.08l1.951-1.952a5.178 5.178 0 01-.944-2.99 5.147 5.147 0 01.864-2.871L5.119 5.885a2.08 2.08 0 11.973-1.268l6.523 5.08a5.183 5.183 0 012.465-1.084V6.236l-.011-.005a1.83 1.83 0 01-1.043-1.644v-.056a1.833 1.833 0 011.827-1.826h.056a1.833 1.833 0 011.827 1.827v.056a1.832 1.832 0 01-1.055 1.648zm-3.469 7.51a2.672 2.672 0 002.665 2.676l.007.002a2.672 2.672 0 002.672-2.672v-.002a2.672 2.672 0 00-5.344-.004z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$1B(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M14 12c0 .543-.198 1.014-.595 1.413-.397.4-.865.6-1.405.6s-1.008-.2-1.405-.6C10.198 13.014 10 12.543 10 12s.198-1.014.595-1.413c.397-.4.865-.599 1.405-.599s1.008.2 1.405.6c.397.398.595.87.595 1.412zm0 5.988c0 .543-.198 1.014-.595 1.413-.397.4-.865.6-1.405.6s-1.008-.2-1.405-.6c-.397-.399-.595-.87-.595-1.413s.198-1.014.595-1.413c.397-.4.865-.599 1.405-.599s1.008.2 1.405.6c.397.398.595.87.595 1.412zm0-11.976c0 .543-.198 1.014-.595 1.413-.397.4-.865.6-1.405.6s-1.008-.2-1.405-.6c-.397-.399-.595-.87-.595-1.413s.198-1.014.595-1.413C10.992 4.199 11.46 4 12 4s1.008.2 1.405.6c.397.398.595.87.595 1.412z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$1A(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.429 3c1.554 0 2.994.389 4.32 1.166a8.558 8.558 0 013.085 3.085A8.393 8.393 0 0121 11.571a8.393 8.393 0 01-1.166 4.32 8.557 8.557 0 01-3.085 3.086 8.392 8.392 0 01-4.32 1.166 8.404 8.404 0 01-2.8-.469 8.31 8.31 0 01-2.412-1.314l1.326-1.349c.579.381 1.196.678 1.851.892a6.53 6.53 0 002.035.32 6.56 6.56 0 003.36-.892 6.71 6.71 0 002.4-2.4 6.56 6.56 0 00.891-3.36 6.56 6.56 0 00-.891-3.36 6.709 6.709 0 00-2.4-2.4 6.56 6.56 0 00-3.36-.891 6.56 6.56 0 00-3.36.891 6.709 6.709 0 00-2.4 2.4 6.56 6.56 0 00-.892 3.36h2.857l-3.84 3.795L1 11.57h2.857c0-1.554.389-2.994 1.166-4.32a8.557 8.557 0 013.086-3.085A8.393 8.393 0 0112.429 3zm1.92 8.571c0 .518-.19.968-.572 1.349-.38.381-.83.571-1.348.571-.518 0-.968-.19-1.349-.571a1.845 1.845 0 01-.571-1.349c0-.518.19-.967.571-1.348.381-.381.83-.572 1.349-.572.518 0 .967.19 1.348.572.381.38.572.83.572 1.348z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$1z(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9.997 16.111l6.01-4.495-6.01-4.52v9.015zm2.019-14.495c1.827 0 3.518.457 5.072 1.37a9.478 9.478 0 013.558 3.558 9.834 9.834 0 011.37 5.072 9.834 9.834 0 01-1.37 5.072 9.478 9.478 0 01-3.558 3.558 9.834 9.834 0 01-5.072 1.37 9.834 9.834 0 01-5.072-1.37 9.657 9.657 0 01-3.558-3.582 9.791 9.791 0 01-1.37-5.048 9.79 9.79 0 011.37-5.048 9.842 9.842 0 013.582-3.582 9.79 9.79 0 015.048-1.37z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$1y(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M21.727 14.39c.086.276.148.504.157.538.315 0 .809.363.809 1.24 0 .87-.36 1.857-.446 2.077-1.301 3.122-4.405 4.86-8.103 4.75-3.447-.102-6.386-1.925-7.673-4.895-.778.001-1.58-.343-2.19-.883-.642-.57-1.038-1.307-1.116-2.077a3.561 3.561 0 01.202-1.644l-.724-.612C-.662 10.086 9.68-1.43 12.988 1.462l1.128 1.106.614-.26c2.901-1.205 5.255-.623 5.258 1.297.002.998-.634 2.163-1.651 3.219.37.342.664.878.834 1.49.142.453.168.913.18 1.206.013.289.026.85.034 1.158l.005.215.408.113c.78.218 1.334.51 1.604.796.271.284.405.56.455.884.045.26.04.721-.305 1.237l.175.468zm-15.313 2.9c.115.003.23-.005.343-.025v.001c1.208-.206 1.524-1.521 1.325-2.812-.225-1.459-1.209-1.972-1.877-2.009a2.037 2.037 0 00-.502.037c-1.191.24-1.865 1.256-1.732 2.576.12 1.195 1.326 2.202 2.443 2.232zm-.904-5.598c-.743.144-1.397.566-1.797 1.148-.239-.2-.685-.587-.763-.737-.64-1.215.696-3.577 1.63-4.911 2.307-3.296 5.917-5.792 7.59-5.339.27.077 1.171 1.122 1.171 1.122S11.67 3.904 10.12 5.2c-2.088 1.61-3.666 3.952-4.611 6.493zm11.76 5.015a.066.066 0 01-.039.065v.001s-1.343.625-3.477-.036c.06.502.547.726.78.817.293.115.614.167.614.167 2.645.456 5.117-1.059 5.674-1.44.042-.029.07-.001.037.05l-.055.077c-.681.881-2.513 1.9-4.896 1.9-1.039 0-2.078-.367-2.46-.93-.591-.875-.03-2.151.957-2.018l.432.048c1.233.138 3.016-.036 4.487-.72 1.346-.625 1.854-1.313 1.777-1.87a.798.798 0 00-.232-.456c-.242-.237-.625-.422-1.272-.604l-.105-.03a7.878 7.878 0 01-.41-.12c-.278-.092-.414-.165-.445-.688-.014-.23-.054-1.025-.068-1.355-.026-.577-.095-1.366-.583-1.691a.817.817 0 00-.418-.134c-.118-.006-.188.01-.226.02l-.022.004c-.263.044-.425.18-.614.339l-.035.029c-.61.508-1.124.592-1.696.567a10.215 10.215 0 01-.556-.045 14.398 14.398 0 00-.564-.048l-.243-.013c-.958-.05-1.986.779-2.157 1.957-.19 1.314.533 2.119 1.004 2.642.116.13.217.242.285.34.043.06.094.144.094.223 0 .095-.062.17-.121.235-.978 1.007-1.29 2.607-.923 3.94.045.165.104.325.174.48.864 2.022 3.546 2.965 6.166 2.108.343-.113.676-.254.995-.422a5.223 5.223 0 001.524-1.14c.695-.728 1.109-1.52 1.269-2.494.079-.521-.037-.723-.194-.82-.166-.103-.365-.067-.365-.067s-.092-.623-.349-1.19c-.764.603-1.747 1.028-2.495 1.243a10.09 10.09 0 01-3.336.361c-.143-.011-.275-.029-.398-.045-.503-.066-.84-.11-.985.36 1.653.607 3.402.348 3.402.348a.062.062 0 01.068.055zM9.768 7.178c.82-.95 1.83-1.774 2.733-2.237.032-.016.065.018.048.048-.072.13-.21.41-.254.62a.037.037 0 00.056.04c.563-.385 1.54-.796 2.4-.849.037-.002.055.045.025.068-.142.11-.269.237-.377.379a.037.037 0 00.028.059c.603.004 1.452.215 2.006.527.037.02.01.093-.031.084-.838-.193-2.21-.34-3.634.01-1.271.31-2.242.79-2.95 1.305-.036.027-.079-.02-.05-.055v.001zm7.798 4.218zm0 0c.152-.02.305-.02.456 0 .081-.188.095-.512.022-.864-.11-.523-.257-.84-.562-.79-.306.049-.318.428-.208.952.062.294.17.546.293.702zm-2.622.414l.034.015c.2.088.322.142.371.09.034-.035.024-.101-.027-.186-.108-.177-.33-.356-.566-.456a1.537 1.537 0 00-1.498.18c-.146.107-.284.256-.265.346.007.03.028.052.08.059.047.005.141-.024.268-.064.194-.062.464-.147.758-.165.343-.021.627.086.845.182zm-.982.478c.101-.087.258-.18.542-.227l.001.001c.392-.046.68.136.746.244.029.047.017.078.008.092-.03.048-.096.04-.232.025l-.01-.001a1.81 1.81 0 00-.916.095s-.145.059-.21.059l-.046-.019-.022-.052c0-.059.053-.142.14-.217zm2.72.695c.192.096.405.058.474-.082.07-.142-.031-.334-.224-.428-.193-.095-.406-.058-.475.082-.07.143.03.334.224.428zm.95-.7c.004-.217.135-.39.291-.387.157.004.28.18.278.396-.003.216-.135.388-.291.385-.157-.002-.28-.18-.277-.395zM7.379 15.785c-.038-.049-.103-.034-.165-.02a.596.596 0 01-.147.02.318.318 0 01-.267-.135c-.072-.11-.067-.274.01-.462l.037-.084c.127-.283.338-.757.101-1.208-.178-.339-.468-.551-.817-.595a1.05 1.05 0 00-.902.325c-.347.383-.401.906-.333 1.09.025.068.063.087.09.09.06.009.147-.034.202-.183l.016-.047c.024-.078.07-.223.144-.34a.63.63 0 01.873-.183c.244.16.338.458.234.744-.054.147-.141.429-.122.66.04.469.327.657.585.678.251.01.427-.133.471-.237.028-.06.005-.098-.009-.114z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$1x(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.6 16.8a2.4 2.4 0 00-2.4 2.4h4.338V24H3.6c-.883 0-1.6-.752-1.6-1.68V9.68C2 8.753 2.717 8 3.6 8h8c.883 0 1.6.753 1.6 1.68v5.787h-1.661a2 2 0 00-2 2v.318A2.397 2.397 0 007.6 16.8zm0-.796c.883 0 1.6-.667 1.6-1.595 0-.927-.717-1.61-1.6-1.61-.883 0-1.6.675-1.6 1.603 0 .928.717 1.602 1.6 1.602z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 12.002v3.465H14v-3.465h16z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M30 11.202V9.6c0-.881-.718-1.6-1.6-1.6H15.6c-.882 0-1.6.719-1.6 1.6v1.602h16zM17.2 9.6a.8.8 0 11-1.6 0 .8.8 0 011.6 0zm4.8 0a.8.8 0 11-1.6 0 .8.8 0 011.6 0zm-2.4 0a.8.8 0 11-1.6 0 .8.8 0 011.6 0z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.6 16c-.883 0-1.6.753-1.6 1.68v12.64c0 .928.717 1.68 1.6 1.68h8c.883 0 1.6-.752 1.6-1.68V17.68c0-.927-.717-1.68-1.6-1.68h-8zm1.6 11.2a2.4 2.4 0 114.8 0h-4.8zm4-4.79c0 .927-.717 1.593-1.6 1.593-.883 0-1.6-.673-1.6-1.601 0-.928.717-1.603 1.6-1.603.883 0 1.6.683 1.6 1.61z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M38 17.6v1.602H22V17.6c0-.881.718-1.6 1.6-1.6h12.8c.882 0 1.6.719 1.6 1.6zm-13.6.8a.8.8 0 100-1.6.8.8 0 000 1.6zm4.8 0a.8.8 0 100-1.6.8.8 0 000 1.6zm-2.4 0a.8.8 0 100-1.6.8.8 0 000 1.6z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 30.293V20.002h16v10.291c0 .942-.718 1.707-1.6 1.707H23.6c-.882 0-1.6-.765-1.6-1.707z"
  }));
}

function SvgComponent$1w(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.022 5.636a13.394 13.394 0 00-.062-2.939c-.043-.277-.108-.695-.404-.695a.337.337 0 00-.105.018c-.302.093-.607.188-.918.31-.766.299-1.496.686-2.173 1.153a8.17 8.17 0 00-.697.557.457.457 0 00-.168.202.624.624 0 00-.016.271c.005.075.005.15 0 .224-.125 2.314-.784 4.68-1.447 6.91-.033.106-.064.223-.098.345l-.029.107a9.62 9.62 0 01-.436 1.35c-.19-.486-.282-1.045-.366-1.557-.022-.137-.044-.27-.067-.397A25.536 25.536 0 013.653 8c-.501 1.191-.599 2.627-.643 3.271l-.01.147c.01.908.105 1.813.283 2.703a9.37 9.37 0 001.095 2.78c.048.079.097.16.145.244l.001.002c.335.57.713 1.21 1.316 1.453.123.05.254.075.386.075.51 0 1.033-.382 1.56-1.136 1.125-1.616 1.717-3.662 2.182-5.454a34.57 34.57 0 001.01-5.885v-.115l.024-.404.02-.045zM3.652 8l-.022.13c0-.04.01-.08.018-.111L3.653 8zm17.23 6.2a29.157 29.157 0 00-.835-6.263c-.46-1.915-1.07-3.874-2.128-5.533 0 0-.3 2.137-2.561 6.82-1.283 2.691-2.792 5.457-4.932 7.578a21.672 21.672 0 004.243-1.299 19.01 19.01 0 01-1.84 3.87c-.708 1.08-1.873 2.389-3.314 1.9.63.35 1.972.606 3.232.67 1.057.049 2.263.023 3.203-.517 1.88-1.08 2.886-3.434 3.591-5.37l.261.417c.253.407.506.813.78 1.2a13.91 13.91 0 00.303-3.481c-.014-.682-.007-.3 0 .044.005.321.01.609-.002-.036zM7.33 18.87c1.437-.89 1.934-2.91 1.934-2.91s.668 2.315 2.899 3.282c0 0-1.03 1.604-2.194 1.604-1.497-.008-2.639-1.975-2.639-1.975z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$1v(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.236,
    fillRule: "evenodd",
    d: "M15 7h3v10h-3V7z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.236,
    fillRule: "evenodd",
    d: "M11 9h3v8h-3V9z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7 11h3v6H7v-6z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$1u(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15.048 9.863c.288-.29.516-.617.684-.983a2.76 2.76 0 00.252-1.166 3.64 3.64 0 00-.54-1.92 3.921 3.921 0 00-1.452-1.405A3.987 3.987 0 0012 3.874c-.72 0-1.384.172-1.992.515a3.921 3.921 0 00-1.452 1.405 3.64 3.64 0 00-.54 1.92h1.968c0-.518.2-.967.6-1.348.4-.381.872-.572 1.416-.572.544 0 1.016.19 1.416.572.4.38.6.823.6 1.325 0 .503-.2.96-.6 1.372l-1.224 1.188a4.165 4.165 0 00-.84 1.235 3.33 3.33 0 00-.336 1.44v.503h1.968c0-.656.112-1.204.336-1.646.144-.29.424-.648.84-1.074l.888-.846zm-2.064 7.36v-1.92h-1.968v1.92h1.968zm6-15.223a2.03 2.03 0 011.416.549c.4.365.6.807.6 1.325v13.349c0 .518-.2.968-.6 1.348-.4.381-.872.572-1.416.572H15L12 22l-3-2.857H5.016c-.56 0-1.036-.19-1.428-.572-.392-.38-.588-.83-.588-1.348V3.874c0-.518.196-.96.588-1.325A2.017 2.017 0 015.016 2h13.968z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$1t(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M14 2l6 6v12a2 2 0 01-2 2H6a2 2 0 01-2-2V4a2 2 0 012-2h8zm4 18V9h-5V4H6v16h12zm-4.5-3.7L16 18v-5l-2.5 1.7V13H8v5h5.5v-1.7z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "a",
    style: {
      maskType: "alpha"
    },
    width: 16,
    height: 20,
    x: 4,
    y: 2,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M14 2l6 6v12a2 2 0 01-2 2H6a2 2 0 01-2-2V4a2 2 0 012-2h8zm4 18V9h-5V4H6v16h12zm-4.5-3.7L16 18v-5l-2.5 1.7V13H8v5h5.5v-1.7z",
    clipRule: "evenodd"
  })));
}

function SvgComponent$1s(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.178 12.04v-1.738s.026-2.344 3.134-2.344c3.109 0 3.135 2.502 2.977 4.083.421-.026.738 1.185-.527 2.66 0 0-.105.949-.737 1.476.684.5 3.134 1.29 3.793 1.87.079.053.158.132.21.184.606.475 1.397 1.607 1.397 3.372a.64.64 0 01-.29.527c-.58.343-2.134.738-6.954.87-5.19.026-7.113-.765-7.113-1.16-.21-.237.027-2.344 1.29-3.609.08-.079.159-.131.264-.21 1.08-.712 2.213-.949 3.846-1.818 0 0-.764-.817-.685-1.422-.5-.37-1.422-2.266-.605-2.74z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M17.611 14.833a1.508 1.508 0 01-.21-.184c-.66-.58-3.109-1.37-3.794-1.87.606-.527.738-1.476.738-1.476 1.264-1.475.948-2.686.526-2.66.159-1.58.132-4.083-2.976-4.083-2.74-.106-3.003 2.186-3.003 2.186V7.3c.158-.026.342.027.527.027 2.74.711 2.634 2.45 2.766 4.32.368.316.421 2.002-.158 2.74 0 0-.501.816-.843 1.554.71.527 2.818 1.211 3.503 1.791.08.053.158.132.237.184.343.264.474.633.764 1.265 1.528-.185 2.74-.264 3.082-.474a.577.577 0 00.29-.527c-.053-1.739-.843-2.871-1.449-3.346z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M21.115 11.277c-.08-.053-.158-.132-.211-.184-.659-.58-3.108-1.37-3.793-1.87.605-.528.737-1.476.737-1.476 1.265-1.475.949-2.687.527-2.66.158-1.581.132-4.083-2.977-4.083-2.74-.106-3.003 2.186-3.003 2.186v.553c.158-.026.343.026.527.026 2.74.712 2.634 2.45 2.766 4.32.369.317.422 2.003-.158 2.74 0 0-.5.817-.843 1.554.711.527 2.819 1.212 3.504 1.792.079.052.158.131.237.184.342.264.474.632.764 1.264 1.527-.184 2.74-.263 3.082-.474a.577.577 0 00.29-.526c-.053-1.74-.87-2.872-1.45-3.346z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$1r(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M14 9h-3v8h3V9zm-4 2H7v6h3v-6z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.236,
    fillRule: "evenodd",
    d: "M15 7h3v10h-3V7z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$1q(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4 6h12a1 1 0 011 1v3.5l4-4v11l-4-4V17a1 1 0 01-1 1H4a1 1 0 01-1-1V7a1 1 0 011-1zm11 10V8H5v8h10z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$1p(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9 16.608L13.608 12 9 7.416 10.416 6l6 6-6 6L9 16.608z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$1o(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M19.26 14.048a6.418 6.418 0 01-.861 1.83l-1.308-1.329c.422-.77.632-1.62.632-2.549 0-.988-.243-1.9-.73-2.734a5.409 5.409 0 00-1.982-1.983 5.336 5.336 0 00-2.734-.73v2.724L8.66 5.66 12.277 2v2.723c1.307 0 2.527.334 3.66 1.002A7.056 7.056 0 0118.55 8.34 7.082 7.082 0 0119.553 12c0 .697-.098 1.38-.294 2.048zm-3.367 4.292L12.277 22v-2.723a7.082 7.082 0 01-3.66-1.003 7.056 7.056 0 01-2.615-2.614A7.082 7.082 0 015 12c0-.697.102-1.376.305-2.037.203-.66.487-1.275.85-1.841l1.307 1.329A5.223 5.223 0 006.83 12c0 .988.243 1.9.73 2.734a5.408 5.408 0 001.982 1.983c.836.486 1.747.73 2.735.73v-2.724l3.616 3.617z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$1n(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M17.016 10.488L21 6.504v10.968l-3.984-3.984v3.528a.93.93 0 01-.3.696c-.2.192-.444.288-.732.288h-12a.948.948 0 01-.696-.288.948.948 0 01-.288-.696V6.984c0-.272.096-.504.288-.696A.948.948 0 013.984 6h12c.288 0 .532.096.732.288.2.192.3.424.3.696v3.504z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$1m(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16.53 8.53l-8 8-1.06-1.06 8-8 1.06 1.06zm1 4l-5 5-1.06-1.06 5-5 1.06 1.06z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$1l(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M8.68 17l1.18-1.18-3.02-3H19.5v-5h-1.68v3.36H6.84l3.02-3L8.68 7l-5 5 5 5z"
  }));
}

function SvgComponent$1k(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4 19v-9H2l3.412-4 3.438 4H7v6h7.382L17 18.999 4 19zM20 6v9h2l-3.413 4-3.436-4H17V9h-7L7 6.001 20 6z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$1j(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16.4 18.667L22 22V2l-5.6 3.333V2L2 12l14.4 10v-3.333z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$1i(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11 4h2v1h1v2h-1v1h4a2 2 0 012 2v10H5V10a2 2 0 012-2h4V7h-1V5h1V4zm0 7.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm3.5 1.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM8 15h8v1a2 2 0 01-2 2h-4a2 2 0 01-2-2v-1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 12h2v4H2v-4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 12h-2v4h2v-4z"
  }));
}

function SvgComponent$1h(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.529 6.976v5.264l4.495 2.669-.745 1.274-5.265-3.197v-6.01h1.515zM12 20.029a7.814 7.814 0 004.038-1.106 7.785 7.785 0 002.885-2.884A7.815 7.815 0 0020.03 12a7.815 7.815 0 00-1.106-4.038 7.785 7.785 0 00-2.885-2.885A7.814 7.814 0 0012 3.97a7.814 7.814 0 00-4.038 1.106 7.785 7.785 0 00-2.885 2.885A7.814 7.814 0 003.97 12c0 1.442.369 2.789 1.106 4.038a7.785 7.785 0 002.885 2.885A7.814 7.814 0 0012 20.03zM12 2c1.827 0 3.518.457 5.072 1.37a9.478 9.478 0 013.558 3.558A9.834 9.834 0 0122 12a9.834 9.834 0 01-1.37 5.072 9.478 9.478 0 01-3.558 3.558A9.834 9.834 0 0112 22a9.834 9.834 0 01-5.072-1.37 9.657 9.657 0 01-3.558-3.582A9.791 9.791 0 012 12a9.79 9.79 0 011.37-5.048A9.842 9.842 0 016.952 3.37 9.79 9.79 0 0112 2z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$1g(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10.9 20.993c-.742-1.475-4.195-5.28 1.668-8.853-.61 2.317 1.786 4.507 2.133 5.088.545.894.02 2.43-.676 3.772 2.64-.16 5.718-2.918 5.955-5.655.223-2.49-1.438-4.64-2.87-6.036l-1.483 1.51C15.594 8.894 17.144 5.696 11.274 3c.204.56 1.294 3.926-4.352 8.125-3.71 2.758-1.871 9.14 3.978 9.868z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$1f(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.82 14.06l3.36-3.12-3.36-3.12v1.8c-2.707.387-4.373 2.013-5 4.88.587-.787 1.28-1.36 2.08-1.72.8-.36 1.773-.54 2.92-.54v1.82zM18.68 17H22v1.68H2V17h3.32a1.54 1.54 0 01-1.17-.5 1.666 1.666 0 01-.47-1.18V7c0-.467.157-.863.47-1.19.313-.327.703-.49 1.17-.49h13.36c.453 0 .84.163 1.16.49.32.327.48.723.48 1.19v8.32c0 .453-.16.847-.48 1.18-.32.333-.707.5-1.16.5z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$1e(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15.864 2v20l5.47-4.071V4.779L15.863 2zm-2.545 15.631L8.915 19.43V3.74l4.405 1.218V17.63zM6.371 16.34L3 17.17l.016-11.352 3.355.505v10.015z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$1d(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M14.298 8.596h4.495l-4.495-4.404v4.404zM17 14v-2H8v2h9zm0 4v-2H8v2h9zM15.135 3L20 7.808v11.615c0 .436-.162.808-.486 1.116a1.613 1.613 0 01-1.149.461H6.635c-.441 0-.824-.154-1.148-.462A1.481 1.481 0 015 19.424l.039-14.846c0-.436.156-.808.467-1.115A1.547 1.547 0 016.635 3h8.5z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$1c(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M15.864 14.32h-.813l-.288-.277A6.66 6.66 0 0016.38 9.69a6.69 6.69 0 10-6.69 6.69 6.66 6.66 0 004.354-1.617l.278.289v.813L19.467 21 21 19.467l-5.136-5.146zm-6.174 0a4.625 4.625 0 01-4.632-4.63A4.625 4.625 0 019.69 5.058a4.625 4.625 0 014.63 4.632 4.625 4.625 0 01-4.63 4.63z"
  }));
}

function SvgComponent$1b(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.833 4c-.46 0-.833.358-.833.8v2.892h10V4.8c0-.442-.373-.8-.833-.8h-8.334zm1.198 2.462c.374 0 .677-.276.677-.616 0-.34-.303-.615-.677-.615-.374 0-.677.275-.677.615 0 .34.303.616.677.616zm2.709-.616c0 .34-.304.616-.677.616-.374 0-.678-.276-.678-.616 0-.34.304-.615.678-.615.373 0 .677.275.677.615zm1.354.616c.374 0 .677-.276.677-.616 0-.34-.303-.615-.677-.615-.374 0-.677.275-.677.615 0 .34.303.616.677.616z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 8.923h10V19.2c0 .442-.373.8-.833.8h-8.334c-.46 0-.833-.358-.833-.8V8.923z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2 4.801c0-.442.373-.8.833-.8h7.5c.46-.001.834.357.834.8V19.2c0 .442-.373.8-.834.8h-7.5c-.46 0-.833-.358-.833-.8V4.801zM6.583 12.8c-1.38 0-2.5 1.074-2.5 2.4h5c0-1.326-1.119-2.4-2.5-2.4zm0-.796c.92 0 1.667-.666 1.667-1.595 0-.927-.747-1.61-1.667-1.61s-1.666.675-1.666 1.603c0 .928.746 1.602 1.666 1.602z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$1a(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M2.01 21L23 12 2.01 3 2 10l15 2-15 2 .01 7z"
  }));
}

function SvgComponent$19(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2.68 20.32L19.32 3.68v5H16v11.64H2.68zm15 0v-1.64h1.64v1.64h-1.64zm0-3.32v-6.68h1.64V17h-1.64z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M17.833 13.417c1.155 0 2.138.362 2.95 1.087.811.724 1.217 1.602 1.217 2.633 0 1.03-.406 1.909-1.217 2.633-.812.725-1.795 1.087-2.95 1.087-1.154 0-2.137-.362-2.949-1.087-.812-.724-1.217-1.602-1.217-2.633 0-.093.008-.225.026-.395l-4.688-2.093c-.798.667-1.745 1-2.838 1-1.155 0-2.138-.362-2.95-1.087C2.406 13.837 2 12.959 2 11.929c0-1.031.406-1.909 1.217-2.634.812-.724 1.795-1.087 2.95-1.087 1.093 0 2.04.334 2.838 1l4.688-2.092a4.17 4.17 0 01-.026-.396c0-1.03.405-1.908 1.217-2.633C15.696 3.362 16.68 3 17.834 3c1.154 0 2.137.362 2.949 1.087C21.594 4.812 22 5.689 22 6.72s-.406 1.909-1.217 2.633c-.812.725-1.795 1.088-2.95 1.088-1.093 0-2.04-.334-2.838-1l-4.688 2.092c.018.17.026.303.026.396 0 .093-.008.224-.026.395l4.688 2.092c.798-.666 1.745-1 2.838-1z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$17(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15.016 14.032c.992 0 2.08.144 3.264.432 1.344.336 2.432.784 3.264 1.344.992.656 1.488 1.392 1.488 2.208v2.016H7v-2.016c0-.816.496-1.552 1.488-2.208.832-.56 1.92-1.008 3.264-1.344 1.184-.288 2.272-.432 3.264-.432zm-9-4.032h3v2.016h-3v3H4v-3H1V10h3V7h2.016v3zm9 2.016a3.84 3.84 0 01-1.992-.54 4.073 4.073 0 01-1.452-1.452 3.84 3.84 0 01-.54-1.992c0-.72.18-1.392.54-2.016a4.016 4.016 0 011.452-1.476A3.84 3.84 0 0115.016 4c.72 0 1.384.18 1.992.54.608.36 1.092.852 1.452 1.476.36.624.54 1.296.54 2.016s-.18 1.384-.54 1.992a4.073 4.073 0 01-1.452 1.452 3.84 3.84 0 01-1.992.54z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M21.557 2.007c-.205.034-.462.158-.712.335L10.336 10.05c-.442.316-.932.96-1.185 1.403l-.217.414a4.837 4.837 0 012.864 1.72c.266.38.47.798.632 1.225l.06-.02c.442-.253 1.086-.762 1.402-1.205l7.763-10.432c.316-.443.446-.877.257-1.068a.287.287 0 00-.178-.079.557.557 0 00-.177 0zM7.966 13.704a2.741 2.741 0 00-2.49 2.232v.12C5.162 18.267 3.834 20.172 2 21.31c.632.317 1.32.506 2.015.633 3.224.442 6.266-1.774 6.835-5v-.197c.19-1.454-.876-2.833-2.33-3.023a2.798 2.798 0 00-.554-.02z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$15(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.45 17v-2H9V8h-.55V6H9V5H1v1h1.55v2H1v7h1.55v2H1v2h8v-2h-.55zM7 17H4v-2h3v2zm0-9H4V6h3v2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M21.45 17v-2H23V8h-1.55V6H23V5h-9v1h1.55v2H14v7h1.55v2H14v2h9v-2h-1.55zM20 17h-3v-2h3v2zm0-9h-3V6h3v2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10 3h3v1h-1v17h1v1h-3v-1h1V4h-1V3z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$14(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6 18l8.5-6L6 6v12zM16 6v12h2V6h-2z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$13(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAA",
    d: "M44.022 26.5h.478V36a.5.5 0 01-.5.5H6a.5.5 0 01-.5-.5V14a.5.5 0 01.5-.5h25.5V25a1.5 1.5 0 001.5 1.5h11.022zm.478-.729l-.125-.125-12.022-12-.146-.146H44a.5.5 0 01.5.5v11.771z"
  }));
}

function SvgComponent$12(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6 13a1 1 0 00-1 1v22a1 1 0 001 1h38a1 1 0 001-1V14a1 1 0 00-1-1H6zm27 13h11.022L32 14v11a1 1 0 001 1z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$11(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9 14H2v-1h7c.808 0 1.5.633 1.5 1.458v21.084C10.5 36.367 9.808 37 9 37H2v-1h7c.296 0 .5-.225.5-.458V14.458c0-.233-.204-.458-.5-.458zm2.5.5A1.5 1.5 0 0113 13h24a1.5 1.5 0 011.5 1.5v21A1.5 1.5 0 0137 37H13a1.5 1.5 0 01-1.5-1.5v-21zM13 14a.5.5 0 00-.5.5v21a.5.5 0 00.5.5h24a.5.5 0 00.5-.5v-21a.5.5 0 00-.5-.5H13zm28 0c-.296 0-.5.225-.5.458v21.084c0 .233.204.458.5.458h7v1h-7c-.808 0-1.5-.633-1.5-1.458V14.458c0-.825.692-1.458 1.5-1.458h7v1h-7z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$10(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7 11h3v6H7v-6zm4-2h3v8h-3V9zm4-2h3v10h-3V7z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$$(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6 13a1 1 0 00-1 1v11.09a1 1 0 001 1h38a1 1 0 001-1V14a1 1 0 00-1-1H6zM5 29.273a1 1 0 011-1h16.823a1 1 0 011 1V36a1 1 0 01-1 1H6a1 1 0 01-1-1v-6.727zm21.177 0a1 1 0 011-1H44a1 1 0 011 1V36a1 1 0 01-1 1H27.177a1 1 0 01-1-1v-6.727z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6 14v-2a2 2 0 00-2 2h2zm0 11.09V14H4v11.09h2zm0 0H4a2 2 0 002 2v-2zm38 0H6v2h38v-2zm0 0v2a2 2 0 002-2h-2zM44 14v11.09h2V14h-2zm0 0h2a2 2 0 00-2-2v2zM6 14h38v-2H6v2zm0 13.273a2 2 0 00-2 2h2v-2zm16.823 0H6v2h16.823v-2zm2 2a2 2 0 00-2-2v2h2zm0 6.727v-6.727h-2V36h2zm-2 2a2 2 0 002-2h-2v2zM6 38h16.823v-2H6v2zm-2-2a2 2 0 002 2v-2H4zm0-6.727V36h2v-6.727H4zm23.177-2a2 2 0 00-2 2h2v-2zm16.823 0H27.177v2H44v-2zm2 2a2 2 0 00-2-2v2h2zM46 36v-6.727h-2V36h2zm-2 2a2 2 0 002-2h-2v2zm-16.823 0H44v-2H27.177v2zm-2-2a2 2 0 002 2v-2h-2zm0-6.727V36h2v-6.727h-2z",
    mask: "url(#a)"
  }));
}

function SvgComponent$_(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6 13a1 1 0 00-1 1v11.09a1 1 0 001 1h38a1 1 0 001-1V14a1 1 0 00-1-1H6zM5 29.273a1 1 0 011-1h16.823a1 1 0 011 1V36a1 1 0 01-1 1H6a1 1 0 01-1-1v-6.727zm21.177 0a1 1 0 011-1H44a1 1 0 011 1V36a1 1 0 01-1 1H27.177a1 1 0 01-1-1v-6.727z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$Z(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M13 20h3v11h-3v-1h2v-9h-2v-1zm20 1H18v9h15v-9zm-15-1h-1v11h17V20H18zm18 0h-1v11h3v-1h-2v-9h2v-1h-2z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13 20v-1h-1v1h1zm3 0h1v-1h-1v1zm0 11v1h1v-1h-1zm-3 0h-1v1h1v-1zm0-1v-1h-1v1h1zm2 0v1h1v-1h-1zm0-9h1v-1h-1v1zm-2 0h-1v1h1v-1zm5 0v-1h-1v1h1zm15 0h1v-1h-1v1zm-15 9h-1v1h1v-1zm15 0v1h1v-1h-1zM17 20v-1h-1v1h1zm0 11h-1v1h1v-1zm17 0v1h1v-1h-1zm0-11h1v-1h-1v1zm1 0v-1h-1v1h1zm0 11h-1v1h1v-1zm3 0v1h1v-1h-1zm0-1h1v-1h-1v1zm-2 0h-1v1h1v-1zm0-9v-1h-1v1h1zm2 0v1h1v-1h-1zm0-1h1v-1h-1v1zm-24-1h-1v2h1v-2zm1 0h-1v2h1v-2zm1 0h-1v2h1v-2zm1 2v-1h-2v1h2zm0 1v-1h-2v1h2zm0 7v-7h-2v7h2zm0 1v-1h-2v1h2zm0 1v-1h-2v1h2zm-2 1h1v-2h-1v2zm-1 0h1v-2h-1v2zm-1 0h1v-2h-1v2zm-1-2v1h2v-1h-2zm2-1h-1v2h1v-2zm1 0h-1v2h1v-2zm-1 0v1h2v-1h-2zm0-7v7h2v-7h-2zm0-1v1h2v-1h-2zm0 1h1v-2h-1v2zm-1 0h1v-2h-1v2zm-1-2v1h2v-1h-2zm6 2h15v-2H18v2zm1 8v-9h-2v9h2zm14-1H18v2h15v-2zm-1-8v9h2v-9h-2zm-15 0h1v-2h-1v2zm1 0v-1h-2v1h2zm0 9v-9h-2v9h2zm0 1v-1h-2v1h2zm0-1h-1v2h1v-2zm15 0H18v2h15v-2zm1 0h-1v2h1v-2zm-1 0v1h2v-1h-2zm0-9v9h2v-9h-2zm0-1v1h2v-1h-2zm0 1h1v-2h-1v2zm-15 0h15v-2H18v2zm17 0h1v-2h-1v2zm1 0v-1h-2v1h2zm0 1v-1h-2v1h2zm0 7v-7h-2v7h2zm0 1v-1h-2v1h2zm0 1v-1h-2v1h2zm0-1h-1v2h1v-2zm1 0h-1v2h1v-2zm1 0h-1v2h1v-2zm-1 0v1h2v-1h-2zm0 1h1v-2h-1v2zm-1 0h1v-2h-1v2zm-1-2v1h2v-1h-2zm0-7v7h2v-7h-2zm0-1v1h2v-1h-2zm2-1h-1v2h1v-2zm1 0h-1v2h1v-2zm-1 0v1h2v-1h-2zm0 1h1v-2h-1v2zm-1 0h1v-2h-1v2z",
    mask: "url(#a)"
  }));
}

function SvgComponent$Y(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M37 16H14v9h23v-9zm-23-1h-1v11h25V15H14zm10 13H14v6h10v-6zm-10-1h-1v8h12v-8H14zm13 1h10v6H27v-6zm-1-1h12v8H26v-8z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14 16v-1h-1v1h1zm23 0h1v-1h-1v1zm-23 9h-1v1h1v-1zm23 0v1h1v-1h-1zM13 15v-1h-1v1h1zm0 11h-1v1h1v-1zm25 0v1h1v-1h-1zm0-11h1v-1h-1v1zM14 28v-1h-1v1h1zm10 0h1v-1h-1v1zm-10 6h-1v1h1v-1zm10 0v1h1v-1h-1zm-11-7v-1h-1v1h1zm0 8h-1v1h1v-1zm12 0v1h1v-1h-1zm0-8h1v-1h-1v1zm12 1h1v-1h-1v1zm-10 0v-1h-1v1h1zm10 6v1h1v-1h-1zm-10 0h-1v1h1v-1zm-1-7v-1h-1v1h1zm12 0h1v-1h-1v1zm0 8v1h1v-1h-1zm-12 0h-1v1h1v-1zM14 17h23v-2H14v2zm1 8v-9h-2v9h2zm22-1H14v2h23v-2zm-1-8v9h2v-9h-2zm-23 0h1v-2h-1v2zm1 0v-1h-2v1h2zm0 9v-9h-2v9h2zm0 1v-1h-2v1h2zm0-1h-1v2h1v-2zm23 0H14v2h23v-2zm1 0h-1v2h1v-2zm-1 0v1h2v-1h-2zm0-9v9h2v-9h-2zm0-1v1h2v-1h-2zm0 1h1v-2h-1v2zm-23 0h23v-2H14v2zm0 13h10v-2H14v2zm1 5v-6h-2v6h2zm9-1H14v2h10v-2zm-1-5v6h2v-6h-2zm-10 0h1v-2h-1v2zm1 0v-1h-2v1h2zm0 6v-6h-2v6h2zm0 1v-1h-2v1h2zm0-1h-1v2h1v-2zm10 0H14v2h10v-2zm1 0h-1v2h1v-2zm-1 0v1h2v-1h-2zm0-6v6h2v-6h-2zm0-1v1h2v-1h-2zm0 1h1v-2h-1v2zm-10 0h10v-2H14v2zm23-1H27v2h10v-2zm1 7v-6h-2v6h2zm-11 1h10v-2H27v2zm-1-7v6h2v-6h-2zm1-2h-1v2h1v-2zm10 0H27v2h10v-2zm1 0h-1v2h1v-2zm1 2v-1h-2v1h2zm0 6v-6h-2v6h2zm0 1v-1h-2v1h2zm-2 1h1v-2h-1v2zm-10 0h10v-2H27v2zm-1 0h1v-2h-1v2zm-1-2v1h2v-1h-2zm0-6v6h2v-6h-2zm0-1v1h2v-1h-2z",
    mask: "url(#a)"
  }));
}

function SvgComponent$X(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5 21h18v9H5v-9zm-1-1h20v11H4V20zm23 1h18v9H27v-9zm-1-1h20v11H26V20z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M23 21h1v-1h-1v1zM5 21v-1H4v1h1zm18 9v1h1v-1h-1zM5 30H4v1h1v-1zM4 20v-1H3v1h1zm20 0h1v-1h-1v1zm0 11v1h1v-1h-1zM4 31H3v1h1v-1zm41-10h1v-1h-1v1zm-18 0v-1h-1v1h1zm18 9v1h1v-1h-1zm-18 0h-1v1h1v-1zm-1-10v-1h-1v1h1zm20 0h1v-1h-1v1zm0 11v1h1v-1h-1zm-20 0h-1v1h1v-1zm-3-11H5v2h18v-2zm1 10v-9h-2v9h2zM5 31h18v-2H5v2zM4 21v9h2v-9H4zm1-2H4v2h1v-2zm18 0H5v2h18v-2zm1 0h-1v2h1v-2zm1 2v-1h-2v1h2zm0 9v-9h-2v9h2zm0 1v-1h-2v1h2zm-2 1h1v-2h-1v2zM5 32h18v-2H5v2zm-1 0h1v-2H4v2zm-1-2v1h2v-1H3zm0-9v9h2v-9H3zm0-1v1h2v-1H3zm42 0H27v2h18v-2zm1 10v-9h-2v9h2zm-19 1h18v-2H27v2zm-1-10v9h2v-9h-2zm1-2h-1v2h1v-2zm18 0H27v2h18v-2zm1 0h-1v2h1v-2zm1 2v-1h-2v1h2zm0 9v-9h-2v9h2zm0 1v-1h-2v1h2zm-2 1h1v-2h-1v2zm-18 0h18v-2H27v2zm-1 0h1v-2h-1v2zm-1-2v1h2v-1h-2zm0-9v9h2v-9h-2zm0-1v1h2v-1h-2z",
    mask: "url(#a)"
  }));
}

function SvgComponent$W(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6 12a1 1 0 00-1 1v10a1 1 0 001 1h38a1 1 0 001-1V13a1 1 0 00-1-1H6zm0 14a1 1 0 00-1 1v10a1 1 0 001 1h38a1 1 0 001-1V27a1 1 0 00-1-1H6z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6 13v-2a2 2 0 00-2 2h2zm0 10V13H4v10h2zm0 0H4a2 2 0 002 2v-2zm38 0H6v2h38v-2zm0 0v2a2 2 0 002-2h-2zm0-10v10h2V13h-2zm0 0h2a2 2 0 00-2-2v2zM6 13h38v-2H6v2zm0 14v-2a2 2 0 00-2 2h2zm0 10V27H4v10h2zm0 0H4a2 2 0 002 2v-2zm38 0H6v2h38v-2zm0 0v2a2 2 0 002-2h-2zm0-10v10h2V27h-2zm0 0h2a2 2 0 00-2-2v2zM6 27h38v-2H6v2z",
    mask: "url(#a)"
  }));
}

function SvgComponent$V(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16 16h18v7H16v-7zm-1-1h20v9H15v-9zm1 12h18v7H16v-7zm-1-1h20v9H15v-9z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M34 16h1v-1h-1v1zm-18 0v-1h-1v1h1zm18 7v1h1v-1h-1zm-18 0h-1v1h1v-1zm-1-8v-1h-1v1h1zm20 0h1v-1h-1v1zm0 9v1h1v-1h-1zm-20 0h-1v1h1v-1zm19 3h1v-1h-1v1zm-18 0v-1h-1v1h1zm18 7v1h1v-1h-1zm-18 0h-1v1h1v-1zm-1-8v-1h-1v1h1zm20 0h1v-1h-1v1zm0 9v1h1v-1h-1zm-20 0h-1v1h1v-1zm19-20H16v2h18v-2zm1 8v-7h-2v7h2zm-19 1h18v-2H16v2zm-1-8v7h2v-7h-2zm1-2h-1v2h1v-2zm18 0H16v2h18v-2zm1 0h-1v2h1v-2zm1 2v-1h-2v1h2zm0 7v-7h-2v7h2zm0 1v-1h-2v1h2zm-2 1h1v-2h-1v2zm-18 0h18v-2H16v2zm-1 0h1v-2h-1v2zm-1-2v1h2v-1h-2zm0-7v7h2v-7h-2zm0-1v1h2v-1h-2zm20 11H16v2h18v-2zm1 8v-7h-2v7h2zm-19 1h18v-2H16v2zm-1-8v7h2v-7h-2zm1-2h-1v2h1v-2zm18 0H16v2h18v-2zm1 0h-1v2h1v-2zm1 2v-1h-2v1h2zm0 7v-7h-2v7h2zm0 1v-1h-2v1h2zm-2 1h1v-2h-1v2zm-18 0h18v-2H16v2zm-1 0h1v-2h-1v2zm-1-2v1h2v-1h-2zm0-7v7h2v-7h-2zm0-1v1h2v-1h-2z",
    mask: "url(#a)"
  }));
}

function SvgComponent$U(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6 12a1 1 0 00-1 1v10a1 1 0 001 1h38a1 1 0 001-1V13a1 1 0 00-1-1H6zm0 14a1 1 0 00-1 1v10a1 1 0 001 1h38a1 1 0 001-1V27a1 1 0 00-1-1H6z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$T(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M1 13a1 1 0 00-1 1v22a1 1 0 001 1h22a1 1 0 001-1V14a1 1 0 00-1-1H1zm26 0a1 1 0 00-1 1v22a1 1 0 001 1h22a1 1 0 001-1V14a1 1 0 00-1-1H27z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$S(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M1 14h22v22H1V14zm-1 0a1 1 0 011-1h22a1 1 0 011 1v22a1 1 0 01-1 1H1a1 1 0 01-1-1V14zm27 0h22v22H27V14zm-1 0a1 1 0 011-1h22a1 1 0 011 1v22a1 1 0 01-1 1H27a1 1 0 01-1-1V14z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M23 14h1v-1h-1v1zM1 14v-1H0v1h1zm22 22v1h1v-1h-1zM1 36H0v1h1v-1zm48-22h1v-1h-1v1zm-22 0v-1h-1v1h1zm22 22v1h1v-1h-1zm-22 0h-1v1h1v-1zm-4-23H1v2h22v-2zm1 23V14h-2v22h2zM1 37h22v-2H1v2zM0 14v22h2V14H0zm1-2a2 2 0 00-2 2h2v-2zm22 0H1v2h22v-2zm2 2a2 2 0 00-2-2v2h2zm0 22V14h-2v22h2zm-2 2a2 2 0 002-2h-2v2zM1 38h22v-2H1v2zm-2-2a2 2 0 002 2v-2h-2zm0-22v22h2V14h-2zm50-1H27v2h22v-2zm1 23V14h-2v22h2zm-23 1h22v-2H27v2zm-1-23v22h2V14h-2zm1-2a2 2 0 00-2 2h2v-2zm22 0H27v2h22v-2zm2 2a2 2 0 00-2-2v2h2zm0 22V14h-2v22h2zm-2 2a2 2 0 002-2h-2v2zm-22 0h22v-2H27v2zm-2-2a2 2 0 002 2v-2h-2zm0-22v22h2V14h-2z",
    mask: "url(#a)"
  }));
}

function SvgComponent$R(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAA",
    d: "M15.5 20.5h19v10h-19z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAA",
    strokeWidth: 0.5,
    d: "M17.25 26.25h13.5v.5h-13.5z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAA",
    strokeWidth: 0.5,
    d: "M17.25 28.25h10.5v.5h-10.5z"
  }));
}

function SvgComponent$Q(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAA",
    d: "M15.5 20.5h19v10h-19z"
  }));
}

function SvgComponent$P(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAA",
    d: "M5.5 15a.5.5 0 01.5-.5h38a.5.5 0 01.5.5v20a.5.5 0 01-.5.5H6a.5.5 0 01-.5-.5V15z"
  }));
}

function SvgComponent$O(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M5 15a1 1 0 011-1h38a1 1 0 011 1v20a1 1 0 01-1 1H6a1 1 0 01-1-1V15z"
  }));
}

function SvgComponent$N(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "#AAA",
    d: "M15.5 18.5h19v10h-19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 30h10v1H16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 32h14v1H16z"
  }));
}

function SvgComponent$M(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5 12a1 1 0 011-1h38a1 1 0 011 1v20a1 1 0 01-1 1H6a1 1 0 01-1-1V12zm0 23h24v1H5v-1zm16 3H5v1h16v-1z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$L(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M44 12H6v20h38V12zM6 11a1 1 0 00-1 1v20a1 1 0 001 1h38a1 1 0 001-1V12a1 1 0 00-1-1H6zM5 35h24v1H5v-1zm16 3H5v1h16v-1z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6 12v-1H5v1h1zm38 0h1v-1h-1v1zM6 32H5v1h1v-1zm38 0v1h1v-1h-1zm-15 3h1v-1h-1v1zM5 35v-1H4v1h1zm24 1v1h1v-1h-1zM5 36H4v1h1v-1zm0 2v-1H4v1h1zm16 0h1v-1h-1v1zM5 39H4v1h1v-1zm16 0v1h1v-1h-1zM6 13h38v-2H6v2zm1 19V12H5v20h2zm37-1H6v2h38v-2zm-1-19v20h2V12h-2zM6 12v-2a2 2 0 00-2 2h2zm0 20V12H4v20h2zm0 0H4a2 2 0 002 2v-2zm38 0H6v2h38v-2zm0 0v2a2 2 0 002-2h-2zm0-20v20h2V12h-2zm0 0h2a2 2 0 00-2-2v2zM6 12h38v-2H6v2zm23 22H5v2h24v-2zm1 2v-1h-2v1h2zM5 37h24v-2H5v2zm-1-2v1h2v-1H4zm1 4h16v-2H5v2zm1 0v-1H4v1h2zm15-1H5v2h16v-2zm-1 0v1h2v-1h-2z",
    mask: "url(#a)"
  }));
}

function SvgComponent$K(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6 13a1 1 0 00-1 1v22a1 1 0 001 1h38a1 1 0 001-1V14a1 1 0 00-1-1H6zm3 14h24v2H9v-2zm0 4h16v2H9v-2z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$J(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2 13h7a1 1 0 011 1v22a1 1 0 01-1 1H2m10-23a1 1 0 011-1h24a1 1 0 011 1v22a1 1 0 01-1 1H13a1 1 0 01-1-1V14zm36 23h-7a1 1 0 01-1-1V14a1 1 0 011-1h7",
    clipRule: "evenodd"
  }));
}

function SvgComponent$I(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M25.333 31.333H31v6.334h-5.667v-6.334zm12 0h-5.666v6.334h5.666v-6.334zm-12-.666H29v-.334h-3.667v.334zm10.334-.334h-4v.334h4v-.334zm-19.334 0h-3.666v.334h3.666v-.334zm22-5.666H11.667V14.333h26.666v10.334zM13 19.5l.533-.533-.166-.167-.7.7.7.7.166-.167L13 19.5zm24.333 0l-.7-.7-.166.167.533.533-.533.533.166.167.7-.7zM25 25.333c-.2 0-.333.134-.333.334S24.8 26 25 26s.333-.133.333-.333-.133-.334-.333-.334zm1.333 0c-.2 0-.333.134-.333.334s.133.333.333.333.334-.133.334-.333-.134-.334-.334-.334zM40 10v30H10V10h30zm-3.333 2h1.666v-.333h-1.666V12zm-2.334 0H36v-.333h-1.667V12zM32 12h1.667v-.333H32V12zm-20.333-.667h1.666V11h-1.666v.333zm0 .667h1.666v-.333h-1.666V12zm0 .667h1.666v-.334h-1.666v.334zm27 14.5H11.333v11.5h27.334v-11.5zm0-13.5H11.333v13.166h27.334V13.667zm-14 17.666H19v6.334h5.667v-6.334zm-2.334-1H19v.334h3.333v-.334zm6-2h-6.666V29h6.666v-.667zm-10 3h-5.666v6.334h5.666v-6.334zM24 25.667c0 .2-.133.333-.333.333s-.334-.133-.334-.333.134-.334.334-.334.333.134.333.334zm-.167 0c0-.1-.066-.167-.166-.167s-.167.067-.167.167.067.166.167.166.166-.066.166-.166z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$H(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M42.302 14H7v23h35.261V14h.041zm-3.595 11.582l-6.579-1.469-1.47-6.565 8.049 8.034zm.776-.245l-8.58-8.523h8.54v8.523h.04zm-9.724-8.523l1.716 7.707c.04.123.122.245.286.286l7.722 1.713v7.707H9.819V16.814h19.94z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$G(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M37.442 39H12.559a.561.561 0 01-.559-.565v-26.87c0-.312.25-.565.559-.565H31.148c.15 0 .285.06.384.156a.197.197 0 01.01.01l6.295 6.37a.566.566 0 01.163.4v20.5c0 .311-.25.564-.558.564zm-24.325-1.129h23.766v-19.39h-5.736a.561.561 0 01-.56-.565V12.13h-17.47v25.742zm18.588-20.52h4.37l-4.37-4.422v4.423zm-.797 15.716a.55.55 0 01-.336-.114.568.568 0 01-.11-.79l3.693-4.955-3.693-4.954a.568.568 0 01.11-.79.554.554 0 01.782.11l3.947 5.295c.15.2.15.478 0 .679l-3.947 5.294a.554.554 0 01-.446.225zm-11.956 0a.555.555 0 01-.446-.225l-3.947-5.294a.568.568 0 010-.68l3.947-5.293c.185-.25.535-.3.782-.112a.568.568 0 01.11.79l-3.694 4.955 3.694 4.955a.568.568 0 01-.11.79.549.549 0 01-.336.114zm2.356-4.056H18.86a.561.561 0 01-.558-.565v-2.475c0-.312.25-.565.558-.565h2.45c.308 0 .558.253.558.565v2.475c0 .312-.25.565-.559.565zm-1.89-1.13h1.332v-1.346h-1.332v1.347zm5.514.72H23.29a.561.561 0 01-.559-.564V26.38c0-.312.25-.565.559-.565h1.64c.31 0 .56.253.56.565v1.658c0 .312-.25.565-.56.565zm-1.082-1.128h.523v-.53h-.523v.53zm3.833.86h-1.11a.561.561 0 01-.558-.564v-1.122c0-.312.25-.564.558-.564h1.11c.31 0 .56.252.56.564v1.122c0 .312-.25.565-.56.565zm2.137-.295h-.525a.561.561 0 01-.559-.564v-.531c0-.312.25-.565.559-.565h.525c.309 0 .559.253.559.565v.53c0 .313-.25.565-.559.565zm1.803-.158h-.212a.561.561 0 01-.559-.564V27.1c0-.312.25-.564.559-.564h.212c.309 0 .559.252.559.564v.215c0 .311-.25.564-.559.564z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$F(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6 22h16v7H6v-7zm-2-2h20v11H4V20zm24 2h16v7H28v-7zm-2-2h20v11H26V20z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M22 22h2v-2h-2v2zM6 22v-2H4v2h2zm16 7v2h2v-2h-2zM6 29H4v2h2v-2zm-2-9v-2H2v2h2zm20 0h2v-2h-2v2zm0 11v2h2v-2h-2zM4 31H2v2h2v-2zm40-9h2v-2h-2v2zm-16 0v-2h-2v2h2zm16 7v2h2v-2h-2zm-16 0h-2v2h2v-2zm-2-9v-2h-2v2h2zm20 0h2v-2h-2v2zm0 11v2h2v-2h-2zm-20 0h-2v2h2v-2zm-4-11H6v4h16v-4zm2 9v-7h-4v7h4zM6 31h16v-4H6v4zm-2-9v7h4v-7H4zm2-4H4v4h2v-4zm16 0H6v4h16v-4zm2 0h-2v4h2v-4zm2 4v-2h-4v2h4zm0 7v-7h-4v7h4zm0 2v-2h-4v2h4zm-4 2h2v-4h-2v4zM6 33h16v-4H6v4zm-2 0h2v-4H4v4zm-2-4v2h4v-2H2zm0-7v7h4v-7H2zm0-2v2h4v-2H2zm42 0H28v4h16v-4zm2 9v-7h-4v7h4zm-18 2h16v-4H28v4zm-2-9v7h4v-7h-4zm2-4h-2v4h2v-4zm16 0H28v4h16v-4zm2 0h-2v4h2v-4zm2 4v-2h-4v2h4zm0 7v-7h-4v7h4zm0 2v-2h-4v2h4zm-4 2h2v-4h-2v4zm-16 0h16v-4H28v4zm-2 0h2v-4h-2v4zm-2-4v2h4v-2h-4zm0-7v7h4v-7h-4zm0-2v2h4v-2h-4z",
    mask: "url(#a)"
  }));
}

function SvgComponent$E(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10zm-10 6a6 6 0 100-12 6 6 0 000 12z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$D(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2 4.8c0-.442.373-.8.833-.8h18.334c.46 0 .833.358.833.8v2.892H2V4.8zm2.708 1.046c0 .34-.303.616-.677.616-.374 0-.677-.276-.677-.616 0-.34.303-.615.677-.615.374 0 .677.275.677.615zm1.354.616c.374 0 .678-.276.678-.616 0-.34-.304-.615-.678-.615-.373 0-.677.275-.677.615 0 .34.304.616.678.616zm2.709-.616c0 .34-.303.616-.677.616-.374 0-.677-.276-.677-.616 0-.34.303-.615.677-.615.374 0 .677.275.677.615z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 8.923H2V19.2c0 .442.373.8.833.8h18.334c.46 0 .833-.358.833-.8V8.923z"
  }));
}

function SvgComponent$C(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M15.417 1.667H4.583C3 1.667 1.667 3 1.667 4.583v10.834C1.667 17 3 18.333 4.583 18.333h8.75l5-5v-8.75C18.333 3 17 1.667 15.417 1.667zm-4.584 11.666H9.167v-2.5h-2.5V9.167h2.5v-2.5h1.666v2.5h2.5v1.666h-2.5v2.5zm1.667 3.334v-1.25c0-1.584 1.333-2.917 2.917-2.917h1.25L12.5 16.667z"
  }));
}

function SvgComponent$B(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
  }));
}

function SvgComponent$A(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12 8a1 1 0 110 2 1 1 0 010-2zm9 3c0 5.55-3.84 10.74-9 12-5.16-1.26-9-6.45-9-12V5l9-4 9 4v6zm-9-5a3 3 0 00-3 3c0 1.31.83 2.42 2 2.83V18h2v-2h2v-2h-2v-2.17c1.17-.41 2-1.52 2-2.83a3 3 0 00-3-3z"
  }));
}

function SvgComponent$z(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16_21)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M18.984 18.584V2.6h-15v15.984h15zm-7.488 4.032c.416 0 .768-.144 1.056-.432.288-.288.432-.64.432-1.056 0-.416-.144-.772-.432-1.068a1.417 1.417 0 00-1.056-.444c-.416 0-.772.144-1.068.432a1.445 1.445 0 00-.444 1.08c0 .432.144.788.432 1.068.288.28.648.42 1.08.42zM18.528-.4c.448 0 .86.112 1.236.336.376.224.676.524.9.9.224.376.336.788.336 1.236v19.056c0 .448-.112.86-.336 1.236a2.552 2.552 0 01-.9.9 2.37 2.37 0 01-1.236.336H4.512c-.448 0-.864-.112-1.248-.336a2.522 2.522 0 01-.912-.9 2.37 2.37 0 01-.336-1.236V2.072c0-.448.112-.86.336-1.236.224-.376.528-.676.912-.9.384-.224.8-.336 1.248-.336h14.016z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16_21"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))));
}

function SvgComponent$y(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M11 8.586L9.707 7.293 8.293 8.707 11 11.415l4.707-4.708-1.414-1.414L11 8.586z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 15.586l-1.293-1.293-1.414 1.414L11 18.415l4.707-4.708-1.414-1.414L11 15.586z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6 2h12c1.103 0 2 .897 2 2v16c0 1.102-.897 2-2 2H6c-1.103 0-2-.898-2-2V4c0-1.103.897-2 2-2zm0 2v16h12.001L18 4H6z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$x(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12 5.5a3.5 3.5 0 110 7 3.5 3.5 0 010-7zM5 8c.56 0 1.08.15 1.53.42-.15 1.43.27 2.85 1.13 3.96A2.997 2.997 0 012 11a3 3 0 013-3zm14 0a3 3 0 010 6c-1.16 0-2.16-.66-2.66-1.62a5.536 5.536 0 001.13-3.96c.45-.27.97-.42 1.53-.42zM5.5 18.25c0-2.07 2.91-3.75 6.5-3.75s6.5 1.68 6.5 3.75V20h-13v-1.75zM0 20v-1.5c0-1.39 1.89-2.56 4.45-2.9-.59.68-.95 1.62-.95 2.65V20H0zm24 0h-3.5v-1.75c0-1.03-.36-1.97-.95-2.65 2.56.34 4.45 1.51 4.45 2.9V20z"
  }));
}

function SvgComponent$w(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.465 2l1.396.93-1.396.93V2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.465 20.14l1.396.93-1.396.93v-1.86z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 10.372h.465v3.721H11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.93 10.372h.465v3.721h-.465z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.861 10.372h.465v3.721h-.465z"
  }));
}

function SvgComponent$v(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 20.032c1.28 0 2.456-.32 3.528-.96a6.986 6.986 0 002.52-2.544A6.888 6.888 0 0018.984 13c0-1.28-.312-2.456-.936-3.528a7.044 7.044 0 00-2.52-2.52A6.888 6.888 0 0012 6.016c-1.28 0-2.456.312-3.528.936a7.044 7.044 0 00-2.52 2.52A6.888 6.888 0 005.016 13c0 1.28.312 2.456.936 3.528a6.986 6.986 0 002.52 2.544c1.072.64 2.248.96 3.528.96zm7.032-12.6A9.044 9.044 0 0120.472 10c.352.96.528 1.96.528 3a8.812 8.812 0 01-1.224 4.536 8.985 8.985 0 01-3.24 3.24A8.812 8.812 0 0112 22a8.812 8.812 0 01-4.536-1.224 8.985 8.985 0 01-3.24-3.24A8.812 8.812 0 013 13c0-1.632.408-3.144 1.224-4.536.8-1.36 1.88-2.44 3.24-3.24A8.812 8.812 0 0112 4c1.024 0 2.032.184 3.024.552a9.91 9.91 0 012.592 1.464l1.416-1.464c.448.368.92.84 1.416 1.416l-1.416 1.464zm-8.016 6.6v-6h1.968v6h-1.968zM15 1v2.016H9V1h6z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$u(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16_122)",
    clipRule: "evenodd",
    filter: "url(#filter0_d_16_122)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2 9h20l-10 6.897L2 9z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#CCC",
    d: "M2 9h20l-10 6.897L2 9z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16_122"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_16_122",
    width: 31.211,
    height: 16.004,
    x: -3.606,
    y: 6.5,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.839216 0 0 0 0 0.839216 0 0 0 0 0.839216 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_16_122"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_16_122",
    result: "shape"
  }))));
}

function SvgComponent$t(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16_119)",
    clipRule: "evenodd",
    filter: "url(#filter0_d_16_119)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M14.397 2v20L7.5 12l6.897-10z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#CCC",
    d: "M14.397 2v20L7.5 12l6.897-10z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16_119"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_16_119",
    width: 16.004,
    height: 31.211,
    x: 2.893,
    y: -1.606,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.839216 0 0 0 0 0.839216 0 0 0 0 0.839216 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_16_119"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_16_119",
    result: "shape"
  }))));
}

function SvgComponent$s(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16_120)",
    clipRule: "evenodd",
    filter: "url(#filter0_d_16_120)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 9l10 6.897H2L12 9z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#CCC",
    d: "M12 9l10 6.897H2L12 9z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16_120"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_16_120",
    width: 31.211,
    height: 16.004,
    x: -3.606,
    y: 6.393,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.839216 0 0 0 0 0.839216 0 0 0 0 0.839216 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_16_120"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_16_120",
    result: "shape"
  }))));
}

function SvgComponent$r(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16_121)",
    clipRule: "evenodd",
    filter: "url(#filter0_d_16_121)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9 22V2l6.897 10L9 22z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#CCC",
    d: "M9 22V2l6.897 10L9 22z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16_121"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_16_121",
    width: 16.004,
    height: 31.211,
    x: 4.5,
    y: -1.606,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.839216 0 0 0 0 0.839216 0 0 0 0 0.839216 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_16_121"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_16_121",
    result: "shape"
  }))));
}

function SvgComponent$q(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.961 3H11.04v8.843h1.922V3zm-5 2.77c.675-.405 1.38-.7 2.116-.885v1.679c-.45.147-.886.348-1.308.602a6.298 6.298 0 00-2.307 2.358 6.494 6.494 0 00-.885 3.301c0 1.18.295 2.28.885 3.302a6.297 6.297 0 002.307 2.358 6.15 6.15 0 003.231.904 6.15 6.15 0 003.23-.904 6.298 6.298 0 002.308-2.358 6.494 6.494 0 00.885-3.302c0-1.179-.295-2.28-.884-3.301a6.298 6.298 0 00-2.308-2.358 6.357 6.357 0 00-1.308-.602V4.88a7.776 7.776 0 012.135.89 7.667 7.667 0 012.846 2.908A8.174 8.174 0 0120 12.825a8.174 8.174 0 01-1.096 4.147 7.667 7.667 0 01-2.846 2.908A7.74 7.74 0 0112 21a7.74 7.74 0 01-4.058-1.12 7.814 7.814 0 01-2.846-2.928A8.138 8.138 0 014 12.825c0-1.48.365-2.856 1.096-4.126A7.962 7.962 0 017.962 5.77z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$p(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 15l5-6H7l5 6z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$o(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 9l5 6H7l5-6z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$n(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 3h-9l-.6 1.8H3v1.8h18V4.8h-3.9L16.5 3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.8 7.5h14.4L17.4 21H6.6L4.8 7.5z"
  }));
}

function SvgComponent$m(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.505 12.203c-.505-1.106-.89-2.572-.89-4.46H3.538v1.154c0 1.178 1.599 2.813 3.967 3.306zm12.957-3.306V7.744h-3.077c0 1.887-.385 3.353-.89 4.459 2.368-.493 3.966-2.128 3.966-3.306zM22 7.231v1.538c0 2.284-2.764 4.808-6.514 4.988a6.47 6.47 0 01-1.142 1.142c-.637.577-.805 1.178-.805 1.947 0 .77.384 1.539 1.538 1.539s2.308.769 2.308 1.923v.769a.38.38 0 01-.385.384H7a.38.38 0 01-.385-.384v-.77c0-1.153 1.154-1.922 2.308-1.922s1.538-.77 1.538-1.539c0-.77-.168-1.37-.805-1.947a6.471 6.471 0 01-1.142-1.142C4.764 13.577 2 11.053 2 8.77V7.231c0-.637.517-1.154 1.154-1.154h3.461V4.923C6.615 3.865 7.481 3 8.538 3h6.923c1.058 0 1.924.865 1.924 1.923v1.154h3.461c.637 0 1.154.517 1.154 1.154z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$l(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M3 17v2h6v-2H3zM3 5v2h10V5H3zm10 16v-2h8v-2h-8v-2h-2v6h2zM7 9v2H3v2h4v2h2V9H7zm14 4v-2H11v2h10zm-6-4h2V7h4V5h-4V3h-2v6z"
  }));
}

function SvgComponent$k(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3 17h18V7H3v10zm8.704-2.248c0 .024-.016.04-.04.04H8.086c-.024 0-.04-.016-.04-.04v-.728c0-.047.016-.079.04-.102l2.145-2.104c.136-.127.528-.498.52-.933-.008-.372-.256-.862-.88-.862a.873.873 0 00-.873.862c0 .024-.016.04-.04.04h-.872c-.024 0-.04-.017-.04-.04 0-.98.76-1.74 1.825-1.74 1.153 0 1.841.767 1.841 1.74 0 .814-.504 1.313-.792 1.574L9.399 13.85c-.024.023-.016.07.024.07h2.241c.024 0 .04.017.04.04v.791zm4.18-3.962c0-.902-.72-1.645-1.794-1.645-1.064 0-1.777.76-1.777 1.74 0 .024.016.04.04.04h.873c.024 0 .04-.017.04-.04 0-.412.328-.87.824-.87.505 0 .833.403.833.775 0 .53-.416.751-.833.751h-.264c-.024 0-.04.016-.04.04v.79c0 .024.016.04.04.04h.264c.473.008.905.253.905.846 0 .364-.368.744-.905.744-.616 0-.856-.538-.856-.823 0-.023-.016-.04-.04-.04h-.88c-.025 0-.04.017-.04.04 0 .894.592 1.693 1.816 1.693 1.265-.008 1.866-.76 1.866-1.614 0-.656-.449-1.099-.737-1.241-.032-.016-.04-.056 0-.08.288-.173.665-.537.665-1.146z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$j(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16_103)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M-3.988 20.597H28V3H-3.988v17.597zm15.468-3.956c0 .042-.028.07-.07.07H5.05c-.043 0-.071-.028-.071-.07v-1.28c0-.084.028-.14.07-.18l3.814-3.703c.241-.223.938-.877.924-1.642-.014-.654-.455-1.517-1.565-1.517-.953 0-1.55.793-1.55 1.517 0 .042-.029.07-.071.07H5.05c-.043 0-.071-.028-.071-.07 0-1.726 1.351-3.062 3.243-3.062 2.049 0 3.272 1.35 3.272 3.062 0 1.433-.896 2.31-1.408 2.77l-2.703 2.449c-.043.042-.028.125.043.125h3.983c.043 0 .071.028.071.07v1.391zm7.428-6.972c0-1.587-1.28-2.895-3.187-2.895-1.892 0-3.158 1.336-3.158 3.062 0 .042.028.07.07.07h1.552c.042 0 .07-.028.07-.07 0-.724.584-1.53 1.466-1.53.896 0 1.48.709 1.48 1.363 0 .932-.74 1.322-1.48 1.322h-.47c-.042 0-.07.028-.07.07v1.391c0 .042.028.07.07.07h.47c.84.014 1.607.445 1.607 1.49 0 .64-.654 1.307-1.607 1.307-1.095 0-1.522-.946-1.522-1.447 0-.042-.029-.07-.071-.07h-1.565c-.043 0-.072.028-.072.07 0 1.573 1.053 2.978 3.23 2.978 2.248-.014 3.315-1.336 3.315-2.839 0-1.155-.797-1.934-1.31-2.185-.056-.028-.07-.097 0-.14.513-.305 1.182-.945 1.182-2.017z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16_103"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))));
}

function SvgComponent$i(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M18.95 7.442a6.42 6.42 0 01-1.536 1.584 8.705 8.705 0 01-.351 2.86 8.9 8.9 0 01-1.096 2.358 9.27 9.27 0 01-1.75 1.997c-.677.579-1.492 1.04-2.447 1.385a8.957 8.957 0 01-3.065.517A8.51 8.51 0 014 16.767c.221.026.468.038.74.038a5.999 5.999 0 003.804-1.309 2.988 2.988 0 01-1.783-.612 2.997 2.997 0 01-1.082-1.513c.209.032.402.047.579.047.272 0 .54-.034.806-.104a3.015 3.015 0 01-1.76-1.058 2.96 2.96 0 01-.697-1.95v-.037c.43.24.892.37 1.385.389a3.06 3.06 0 01-.996-1.091 2.986 2.986 0 01-.37-1.461c0-.557.14-1.072.418-1.546a8.686 8.686 0 002.793 2.262 8.538 8.538 0 003.525.944 3.403 3.403 0 01-.076-.702c0-.847.299-1.57.896-2.168A2.953 2.953 0 0114.35 6c.885 0 1.632.323 2.239.968a6.009 6.009 0 001.945-.74 2.975 2.975 0 01-1.348 1.688 6.105 6.105 0 001.765-.474z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$h(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M14.996 14.06c.99 0 2.077.144 3.259.433 1.342.337 2.428.787 3.26 1.348.99.658 1.485 1.396 1.485 2.214v2.022H6.991v-2.022c0-.818.496-1.556 1.486-2.214.83-.561 1.917-1.01 3.26-1.348 1.182-.289 2.268-.433 3.259-.433zm-5.992-4.043v2.022H1v-2.022h8.004zm5.992 2.022a3.82 3.82 0 01-1.99-.542 4.076 4.076 0 01-1.45-1.456 3.863 3.863 0 01-.539-1.998c0-.722.18-1.396.54-2.021a4.02 4.02 0 011.45-1.48A3.822 3.822 0 0114.996 4c.719 0 1.382.18 1.989.542.607.36 1.09.854 1.45 1.48.36.625.539 1.3.539 2.021 0 .722-.18 1.388-.54 1.998a4.075 4.075 0 01-1.45 1.456 3.82 3.82 0 01-1.988.542z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$g(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.686 13.604L6 12.527 12.01 7 18 12.527l-.593 1.077-5.398-5.011-5.323 5.011zm0 3.396L6 15.923l6.01-5.527L18 15.923 17.407 17l-5.398-5.012L6.686 17z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$f(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2 4.8c0-.442.373-.8.833-.8h18.334c.46 0 .833.358.833.8v14.4c0 .442-.373.8-.833.8H2.833c-.46 0-.833-.358-.833-.8V4.8zm10 4c-.46 0-.833.358-.833.8v1.6H9.5c-.46 0-.833.358-.833.8 0 .442.373.8.833.8h1.667v1.6c0 .442.373.8.833.8.46 0 .833-.358.833-.8v-1.6H14.5c.46 0 .833-.358.833-.8 0-.442-.373-.8-.833-.8h-1.667V9.6c0-.442-.373-.8-.833-.8zM3.667 6.4c0-.442.373-.8.833-.8.46 0 .833.358.833.8V8c0 .442-.373.8-.833.8-.46 0-.833-.358-.833-.8V6.4zm0 4.8c0-.442.373-.8.833-.8.46 0 .833.358.833.8v1.6c0 .442-.373.8-.833.8-.46 0-.833-.358-.833-.8v-1.6zm.833 4c-.46 0-.833.358-.833.8v1.6c0 .442.373.8.833.8.46 0 .833-.358.833-.8V16c0-.442-.373-.8-.833-.8zm14.167-8.8c0-.442.373-.8.833-.8.46 0 .833.358.833.8V8c0 .442-.373.8-.833.8-.46 0-.833-.358-.833-.8V6.4zm.833 4c-.46 0-.833.358-.833.8v1.6c0 .442.373.8.833.8.46 0 .833-.358.833-.8v-1.6c0-.442-.373-.8-.833-.8zm-.833 5.6c0-.442.373-.8.833-.8.46 0 .833.358.833.8v1.6c0 .442-.373.8-.833.8-.46 0-.833-.358-.833-.8V16z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$e(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2 4.8c0-.442.373-.8.833-.8h18.334c.46 0 .833.358.833.8v14.4c0 .442-.373.8-.833.8H2.833c-.46 0-.833-.358-.833-.8V4.8zm7.5 5.125c0-.604.67-.99 1.225-.706l4.06 2.075a.785.785 0 010 1.412l-4.06 2.075c-.555.284-1.225-.102-1.225-.706v-4.15zM3.667 6.4c0-.442.373-.8.833-.8.46 0 .833.358.833.8V8c0 .442-.373.8-.833.8-.46 0-.833-.358-.833-.8V6.4zm0 4.8c0-.442.373-.8.833-.8.46 0 .833.358.833.8v1.6c0 .442-.373.8-.833.8-.46 0-.833-.358-.833-.8v-1.6zm.833 4c-.46 0-.833.358-.833.8v1.6c0 .442.373.8.833.8.46 0 .833-.358.833-.8V16c0-.442-.373-.8-.833-.8zm14.167-8.8c0-.442.373-.8.833-.8.46 0 .833.358.833.8V8c0 .442-.373.8-.833.8-.46 0-.833-.358-.833-.8V6.4zm.833 4c-.46 0-.833.358-.833.8v1.6c0 .442.373.8.833.8.46 0 .833-.358.833-.8v-1.6c0-.442-.373-.8-.833-.8zm-.833 5.6c0-.442.373-.8.833-.8.46 0 .833.358.833.8v1.6c0 .442-.373.8-.833.8-.46 0-.833-.358-.833-.8V16z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$d(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.178 12.04v-1.738s.026-2.344 3.134-2.344c3.109 0 3.135 2.502 2.977 4.083.421-.026.738 1.185-.527 2.66 0 0-.105.949-.737 1.476.684.5 3.134 1.29 3.793 1.87.079.053.158.132.21.184.606.475 1.397 1.607 1.397 3.372a.64.64 0 01-.29.527c-.58.343-2.134.738-6.954.87-5.19.026-7.113-.765-7.113-1.16-.21-.237.027-2.344 1.29-3.609.08-.079.159-.131.264-.21 1.08-.712 2.213-.949 3.846-1.818 0 0-.764-.817-.685-1.422-.5-.37-1.422-2.266-.605-2.74z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M17.611 14.833a1.503 1.503 0 01-.21-.184c-.66-.58-3.109-1.37-3.794-1.87.606-.527.738-1.476.738-1.476 1.264-1.475.948-2.686.527-2.66.158-1.58.131-4.083-2.977-4.083-2.74-.106-3.003 2.186-3.003 2.186V7.3c.158-.026.342.027.527.027 2.74.711 2.634 2.45 2.766 4.32.368.316.421 2.002-.158 2.74 0 0-.5.816-.843 1.554.71.527 2.818 1.211 3.503 1.791.08.053.158.132.237.184.343.264.474.633.764 1.265 1.528-.185 2.74-.264 3.082-.474a.577.577 0 00.29-.527c-.053-1.739-.843-2.871-1.449-3.346z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M21.115 11.277c-.08-.053-.158-.132-.211-.184-.659-.58-3.108-1.37-3.793-1.87.605-.528.737-1.476.737-1.476 1.265-1.475.949-2.687.527-2.66.158-1.581.132-4.083-2.977-4.083-2.74-.106-3.003 2.186-3.003 2.186v.553c.158-.026.343.026.527.026 2.74.712 2.634 2.45 2.766 4.32.369.317.422 2.003-.158 2.74 0 0-.5.817-.843 1.554.711.527 2.819 1.212 3.504 1.792.079.052.158.131.237.184.342.264.474.632.764 1.264 1.527-.184 2.74-.263 3.082-.474a.577.577 0 00.29-.526c-.053-1.74-.87-2.872-1.45-3.346z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$c(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.999 15.194a2.941 2.941 0 100-5.883 2.941 2.941 0 000 5.883z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.007 5C6.545 5 2 11.157 2 12.293c0 1.136 4.545 7.212 10.007 7.212s10.09-5.994 9.991-7.212C22.098 11.157 17.47 5 12.007 5zm0 12.506a5.254 5.254 0 11.001-10.505 5.254 5.254 0 01-.001 10.505z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$b(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M20 14H4V8h5.08L7 10.83 8.62 12 11 8.76l1-1.36 1 1.36L15.38 12 17 10.83 14.92 8H20v6zm0 5H4v-2h16v2zM9 4a1 1 0 110 2 1 1 0 010-2zm6 0a1 1 0 110 2 1 1 0 010-2zm5 2h-2.18c.11-.31.18-.65.18-1a3 3 0 00-3-3c-1.05 0-1.96.54-2.5 1.35L12 4l-.5-.66A3 3 0 006 5c0 .35.07.69.18 1H4c-1.11 0-2 .89-2 2v11c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2z"
  }));
}

function SvgComponent$a(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5 9.086c.416-.492.832-.93 1.248-1.316a8.59 8.59 0 011.083-.88c.306-.2.58-.363.823-.487a3.84 3.84 0 01.544-.244l.193-.046c.09-.015.181-.022.272-.022a1.01 1.01 0 01.88.46c.124.184.234.392.328.623.095.23.176.503.244.817.068.314.125.607.17.879l.153.902c.057.329.112.595.165.8.242.945.437 1.616.584 2.013.148.397.305.596.47.596.182 0 .434-.21.755-.63.322-.42.675-.992 1.06-1.719.198-.363.296-.707.296-1.032 0-.098-.008-.185-.023-.26-.068-.394-.26-.64-.578-.738a.791.791 0 00-.273-.045c-.264 0-.578.098-.941.294.166-.983.673-1.773 1.52-2.37.643-.454 1.3-.681 1.974-.681.09 0 .181.004.272.011.771.06 1.297.401 1.577 1.021.136.288.204.62.204.999 0 .219-.023.45-.068.692a8.973 8.973 0 01-.788 2.359c-.39.802-.817 1.51-1.282 2.127a19.013 19.013 0 01-1.503 1.758c-.537.556-1.004.998-1.401 1.327-.397.33-.74.588-1.027.778-.318.181-.614.272-.89.272-.277 0-.54-.08-.789-.238a2.802 2.802 0 01-.635-.545 3.21 3.21 0 01-.431-.646c-.136-.288-.505-1.417-1.106-3.387-.601-1.97-.966-3.03-1.095-3.182a.128.128 0 00-.045-.045.569.569 0 00-.153-.051.658.658 0 00-.273 0 1.7 1.7 0 00-.414.159c-.174.087-.363.21-.567.368L5 9.086z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$9(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-5 14H4v-4h11v4zm0-5H4V9h11v4zm5 5h-4V9h4v9z"
  }));
}

function SvgComponent$8(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M21.79 19.271L12.85 4.575c-.466-.767-1.23-.767-1.697 0L2.21 19.271c-.468.768-.124 1.396.762 1.396h18.058c.886 0 1.23-.628.762-1.396zm-9.712-1.266a1.008 1.008 0 110-2.015 1.008 1.008 0 010 2.015zm1.008-2.822H11.07V9.54h2.016v5.644z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$7(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7 2.417a.417.417 0 01.833 0v.416h8.334v-.416a.417.417 0 11.833 0v.416h2.5a2.5 2.5 0 012.5 2.5v15a2.5 2.5 0 01-2.5 2.5h-15a2.5 2.5 0 01-2.5-2.5v-15a2.5 2.5 0 012.5-2.5H7v-.416zm9.167 1.25V5.75a.417.417 0 10.833 0V3.667h2.5c.92 0 1.667.746 1.667 1.666v15c0 .92-.747 1.667-1.667 1.667h-15c-.92 0-1.667-.746-1.667-1.667v-15c0-.92.747-1.666 1.667-1.666H7V5.75a.417.417 0 00.833 0V3.667h8.334zm-1.579 7.611l.514-.394a3.136 3.136 0 00-1.229-1.027c-.5-.238-1.066-.357-1.695-.357-.63 0-1.218.15-1.765.45A3.28 3.28 0 009.13 11.19a3.367 3.367 0 00-.463 1.728c0 1.008.333 1.843.999 2.503.666.66 1.521.99 2.566.99.6 0 1.146-.112 1.641-.335a3.127 3.127 0 001.229-.976l-.257-.197-.257-.197c-.617.72-1.39 1.081-2.319 1.081-.83 0-1.523-.267-2.076-.802-.553-.535-.83-1.2-.83-1.998s.283-1.471.848-2.021a2.798 2.798 0 012.021-.825c.96 0 1.745.379 2.356 1.136z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$6(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M14.886 14.159l.836-.836h.008c.573-.573.511-1.13-.062-1.703l-4.057-3.866-1.604 1.667 4.88 4.738z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M19.987 7.801L11.478 0l-.001.009-8.42 7.885a6.498 6.498 0 00-.157 9.334l5.481 5.488a4.375 4.375 0 006.165.027l5.608-5.519a6.496 6.496 0 00-.167-9.423zm-8.454-2.845l5.647 5.506-.005.006c1.163 1.162 1.275 3.05.069 4.262l-2.187 2.179-6.464-6.239-1.349 1.318c-.446.446-.487.969-.04 1.416l4.329 4.139-.027 2.723-6.181-5.99c-.79-.79-.735-2.686-.082-3.34l6.29-5.98z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$5(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "a",
    style: {
      maskType: "alpha"
    },
    width: 20,
    height: 16,
    x: 2,
    y: 4,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 4H2v15.564h20V4H12z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.202 12.337c-.985.62-3.031 1.279-5.662 1.533-1.42.138-4.036.026-5.158.026-1.127 0-1.644.238-2.656 1.377l-3.73 4.204s1.292.006 2.268.006c.975 0 7.074.354 9.78-.39 8.79-2.416 7.933-9.135 7.933-9.135s-.463.922-2.775 2.379z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.741 7.287C22.164 4.709 20.707 4 20.707 4s.062 2.1-3.796 2.544c-3.424.395-14.914.097-14.914.097l3.693 4.235c1 1.148 1.53 1.281 2.655 1.36 1.125.076 3.606.05 5.289-.079 1.839-.14 4.46-.74 6.232-2.113.908-.703 1.699-1.68 1.875-2.757z"
  })));
}

function SvgComponent$4(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16 12.002c0-.193-.094-.333-.281-.421l-4.8-2.499a.662.662 0 00-.61-.015c-.206.093-.309.239-.309.437V14.5c0 .198.103.344.31.438.1.041.196.062.29.062a.612.612 0 00.319-.078l4.8-2.498c.187-.089.281-.23.281-.422zm6-.216c0 .678-.003 1.208-.01 1.59-.008.382-.038.864-.09 1.447a11.723 11.723 0 01-.24 1.564 2.48 2.48 0 01-.73 1.304 2.236 2.236 0 01-1.316.615c-1.569.177-3.94.265-7.114.265s-5.545-.088-7.114-.265a2.26 2.26 0 01-1.32-.615 2.465 2.465 0 01-.737-1.304c-.1-.46-.175-.98-.228-1.564a20.798 20.798 0 01-.09-1.447c-.007-.382-.011-.912-.011-1.59 0-.679.004-1.209.01-1.59.008-.382.038-.865.09-1.448.054-.583.133-1.104.24-1.564a2.48 2.48 0 01.73-1.304 2.236 2.236 0 011.316-.615C6.955 5.088 9.326 5 12.5 5s5.545.088 7.114.265a2.26 2.26 0 011.32.615c.379.353.624.788.737 1.304.1.46.175.98.228 1.564.053.583.083 1.066.09 1.447.008.382.011.912.011 1.59z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M13.427 15.107v1.884c0 .399-.117.598-.349.598-.136 0-.27-.065-.401-.196v-2.688c.13-.13.265-.196.401-.196.232 0 .349.2.349.598zm3.017.01v.41h-.804v-.41c0-.406.134-.608.402-.608s.402.202.402.607zM7.82 13.17h.955v-.84H5.99v.84h.937v5.08h.893v-5.08zm2.57 5.08h.795v-4.41h-.794v3.374c-.179.25-.349.375-.51.375-.106 0-.169-.062-.187-.187a2.486 2.486 0 01-.009-.313v-3.25h-.794v3.491c0 .292.024.51.071.652.072.22.244.33.518.33.286 0 .59-.181.91-.544v.482zm3.83-1.321v-1.76c0-.434-.027-.729-.08-.883-.101-.334-.313-.5-.634-.5-.298 0-.574.16-.83.482V12.33h-.795v5.92h.795v-.429c.268.328.544.491.83.491.321 0 .533-.163.634-.49.053-.161.08-.459.08-.893zm3.017-.09v-.116h-.812c0 .304-.006.485-.018.545-.042.214-.16.321-.357.321-.274 0-.41-.205-.41-.616v-.777h1.597v-.92c0-.47-.08-.815-.24-1.035-.233-.303-.548-.455-.947-.455-.405 0-.723.152-.955.455-.167.22-.25.566-.25 1.036v1.544c0 .47.086.816.259 1.036.232.304.553.456.964.456.428 0 .75-.158.964-.474.107-.16.17-.321.187-.482.012-.053.018-.226.018-.518zm-5.427-8.151V6.812c0-.41-.128-.616-.384-.616s-.384.206-.384.617v1.875c0 .416.128.624.384.624s.384-.208.384-.624zm6.418 6.705c0 1.393-.077 2.434-.232 3.125a1.696 1.696 0 01-.518.884 1.562 1.562 0 01-.91.41c-1.095.125-2.747.188-4.954.188-2.208 0-3.86-.063-4.955-.188a1.582 1.582 0 01-.915-.41 1.632 1.632 0 01-.513-.884C5.077 17.85 5 16.809 5 15.393c0-1.393.077-2.435.232-3.125.083-.351.256-.646.518-.884s.568-.378.92-.42c1.088-.119 2.737-.178 4.944-.178 2.208 0 3.86.06 4.955.178.345.042.65.182.915.42.264.238.435.533.513.884.155.666.232 1.708.232 3.125zM9.32 4h.91L9.15 7.563v2.42h-.892v-2.42c-.083-.441-.265-1.072-.544-1.893-.22-.613-.414-1.17-.58-1.67h.946l.633 2.348L9.32 4zm3.303 2.973v1.563c0 .482-.083.833-.25 1.053-.22.304-.535.456-.946.456-.399 0-.711-.152-.937-.456-.167-.226-.25-.577-.25-1.053V6.973c0-.476.083-.824.25-1.044.226-.304.538-.456.937-.456.41 0 .726.152.946.456.167.22.25.568.25 1.044zm2.99-1.446v4.455h-.812v-.49c-.315.368-.622.553-.92.553-.273 0-.449-.11-.526-.33-.048-.144-.071-.367-.071-.67V5.527h.812v3.277c0 .196.003.3.009.312.018.131.08.197.187.197.161 0 .33-.128.51-.384V5.527h.812z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M44 14H6v22h38V14zM6 13a1 1 0 00-1 1v22a1 1 0 001 1h38a1 1 0 001-1V14a1 1 0 00-1-1H6zm4 14H9v1h24v-1H10zm-1 4h16v1H9v-1z",
    clipRule: "evenodd"
  }));
}

function SvgComponent$1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M17.016 16.616v-4.032h1.968v6h-12v3L3 17.6l3.984-3.984v3h10.032zM6.984 6.584v4.032H5.016v-6h12v-3L21 5.6l-3.984 3.984v-3H6.984z",
    clipRule: "evenodd"
  }));
}

function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M18.527 15.608l-5.94-4.39 5.94-4.392s-1.372-1.935-3.342-.549l-4.641 3.477-3.157-2.379-1.3 1.83 2.6 2.012-2.6 2.013 1.115 1.647 3.342-2.379 5.198 3.66s1.671.914 2.785-.55z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.22 7.11a3.11 3.11 0 10-6.22 0 3.11 3.11 0 006.22 0zm-4.9 0a1.79 1.79 0 113.58 0 1.79 1.79 0 01-3.58 0z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.22 15.995a3.11 3.11 0 10-6.22 0 3.11 3.11 0 006.22 0zm-4.9 0a1.79 1.79 0 113.58 0 1.79 1.79 0 01-3.58 0z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.39 11.518v-.426h2.473v.426H11.39zm4.069 0v-.426h2.473v.426h-2.473zm4.068 0v-.426H22v.426h-2.473z",
    clipRule: "evenodd"
  }));
}

export { SvgComponent$3T as AccountCircle, SvgComponent$3K as AccountMultiple, SvgComponent$3M as AccountMultiplePlus, SvgComponent$3R as Activity, SvgComponent$3z as AddPhoto, SvgComponent$3S as Api, SvgComponent$3P as ArrowLeft, SvgComponent$3Q as ArrowRight, SvgComponent$3O as Assign, SvgComponent$3N as Audience, SvgComponent$2r as Batch, SvgComponent$3D as Bullhorn, SvgComponent$3u as Business, SvgComponent$3L as Business2, SvgComponent$3J as CalendarClock, SvgComponent$3I as Cam, SvgComponent$3H as CameraFlip, SvgComponent$3G as CameraOff, SvgComponent$3F as CameraPlus, SvgComponent$3E as CancelCircle, SvgComponent$3C as CardAccountDetails, SvgComponent$3A as Chat, SvgComponent$3B as Check, SvgComponent$3k as CheckMark, SvgComponent$3w as ChevronDown, SvgComponent$3t as ChevronLeft, SvgComponent$3x as ChevronRight, SvgComponent$3y as ChevronUp, SvgComponent$37 as Close, SvgComponent$3s as Cog, SvgComponent$3v as CogSquare, SvgComponent$3r as Collector, SvgComponent$3q as CommentQuestion, SvgComponent$3p as Company, SvgComponent$3o as Config, SvgComponent$3n as ConnectionTest, SvgComponent$3m as Connector, SvgComponent$3e as ConversionArrows, SvgComponent$3l as Copy, SvgComponent$3j as Creation, SvgComponent$3i as CreditCard, SvgComponent$3f as Css3, SvgComponent$3h as Csv, SvgComponent$3g as Dashboard, SvgComponent$2D as Date, SvgComponent$3d as Delete, SvgComponent$3c as Desktop, SvgComponent$3b as DevicesChange, SvgComponent$3a as DigitalEvent, SvgComponent$39 as Dislikes, SvgComponent$38 as Download, SvgComponent$36 as Draft, SvgComponent$2O as Duplicate, SvgComponent$35 as Edit, SvgComponent$2Y as Email, SvgComponent$34 as EmailFill, SvgComponent$33 as EmailSent, SvgComponent$32 as Embed, SvgComponent$30 as Episodic, SvgComponent$31 as Error, SvgComponent$2$ as Excel, SvgComponent$2_ as ExitFullScreen, SvgComponent$2Z as Eye, SvgComponent$2U as Facebook, SvgComponent$2V as FileAttachment, SvgComponent$2X as FileDocument, SvgComponent$2W as Flow, SvgComponent$2R as Folder, SvgComponent$2T as FolderFill, SvgComponent$2S as FolderMore, SvgComponent$2P as FolderPlus, SvgComponent$2Q as Forum, SvgComponent$2l as Forward, SvgComponent$2N as FrameForward, SvgComponent$2M as FrameRewind, SvgComponent$2K as FullScreen, SvgComponent$2L as GearMode, SvgComponent$2I as Github, SvgComponent$2J as Google, SvgComponent$2H as Handshake, SvgComponent$2G as Help, SvgComponent$2F as Highlight, SvgComponent$2E as HighlightAlt, SvgComponent$2C as Home, SvgComponent$2q as Hubspot, SvgComponent$2z as Image, SvgComponent$2B as Import, SvgComponent$2y as Import_contacts, SvgComponent$2A as Info, SvgComponent$2x as Integration, SvgComponent$2w as Javascript, SvgComponent$2v as Labs, SvgComponent$2u as Likes, SvgComponent$2s as Link, SvgComponent$2t as LinkOnly, SvgComponent$22 as LinkedIn, SvgComponent$2p as LiveViewers, SvgComponent$26 as Lock, SvgComponent$2n as LockFill, SvgComponent$2o as LockOpenOutline, SvgComponent$2f as LockOutline, SvgComponent$2m as LogOut, SvgComponent$2i as MagnifyMinus, SvgComponent$2k as MagnifyPlus, SvgComponent$2j as MicrophoneOff, SvgComponent$2g as MicrophoneOn, SvgComponent$2h as MinusCircle, SvgComponent$2e as Mobile, SvgComponent$2c as Money, SvgComponent$2a as More, SvgComponent$2d as MoreHotizontal, SvgComponent$1B as MoreVertical, SvgComponent$2b as More_horiz, SvgComponent$29 as Movie, SvgComponent$28 as Mp3, SvgComponent$1t as Mp4, SvgComponent$27 as MultiplyClip, SvgComponent$24 as MuteNotification, SvgComponent$25 as NewTimelineHandle, SvgComponent$23 as Ondemand, SvgComponent$1H as Pause, SvgComponent$20 as Pdf, SvgComponent$21 as PdfOld, SvgComponent$1$ as People, SvgComponent$1_ as Person, SvgComponent$1Y as PinDrop, SvgComponent$1X as Play, SvgComponent$1Z as PlayArrow, SvgComponent$1V as Playback, SvgComponent$1W as PlayerDesigner, SvgComponent$1T as Plus, SvgComponent$1U as PlusCircleOutline, SvgComponent$1S as Png, SvgComponent$1P as Poll, SvgComponent$1R as PollBox, SvgComponent$1Q as Popout, SvgComponent$1O as PowerMode, SvgComponent$1N as Presentation, SvgComponent$1L as Preview, SvgComponent$1M as ProSignal, SvgComponent$1K as Public, SvgComponent$1E as PvCampMonitor, SvgComponent$1J as PvChevronDown, SvgComponent$1I as PvChevronLeft, SvgComponent$1p as PvChevronRight, SvgComponent$1G as PvChevronUp, SvgComponent$1F as PvGif, SvgComponent$1D as PvGmail, SvgComponent$1C as PvHubspot, SvgComponent$1y as PvMailchimp, SvgComponent$1e as PvMarketo, SvgComponent$1z as PvPlayPreview, SvgComponent$1A as PvReactivate, SvgComponent$1w as PvSharpspring, SvgComponent$1x as PvStacked, SvgComponent$1v as QualityBad, SvgComponent$10 as QualityGood, SvgComponent$1r as QualityMedium, SvgComponent$1u as Questions, SvgComponent$1s as Reach, SvgComponent$1n as Record, SvgComponent$1q as RecordOutline, SvgComponent$1o as Refresh, SvgComponent$1 as Repeat, SvgComponent$1m as Resize, SvgComponent$1l as Return, SvgComponent$1k as Retweets, SvgComponent$1j as Rewind, SvgComponent$1i as Robot, SvgComponent$1h as Schedule, SvgComponent$1g as Score, SvgComponent$D as Screen, SvgComponent$1f as ScreenShare, SvgComponent$1d as Script, SvgComponent$1c as Search, SvgComponent$1a as Send, SvgComponent$18 as Share, SvgComponent$1b as Sidebyside, SvgComponent$19 as SignalBad, SvgComponent$17 as Signups, SvgComponent$16 as SiteDesigner, SvgComponent$14 as Skip_next, SvgComponent$15 as SplitRange, SvgComponent$12 as SpotAmbient, SvgComponent$13 as SpotAmbientEmpty, SvgComponent$J as SpotCarousel, SvgComponent$11 as SpotCarouselEmpty, SvgComponent$_ as SpotGrid, SvgComponent$$ as SpotGridEmpty, SvgComponent$Z as SpotLayoutCarousel, SvgComponent$Y as SpotLayoutGrid, SvgComponent$V as SpotLayoutList, SvgComponent$X as SpotLayoutRow, SvgComponent$U as SpotList, SvgComponent$W as SpotListEmpty, SvgComponent$T as SpotRow, SvgComponent$S as SpotRowEmpty, SvgComponent$R as SpotThumbnailInside, SvgComponent$Q as SpotThumbnailNone, SvgComponent$N as SpotThumbnailOutside, SvgComponent$O as SpotThumbnailTextHover, SvgComponent$P as SpotThumbnailTextHoverEmpty, SvgComponent$M as SpotThumbnailTextOut, SvgComponent$L as SpotThumbnailTextOutEmpty, SvgComponent$K as SpotThumbnails, SvgComponent$2 as SpotThumbnailsEmpty, SvgComponent$H as SpotTypeAmbient, SvgComponent$I as SpotTypeCarousel, SvgComponent$G as SpotTypeProduct, SvgComponent$F as SpotTypeThumbnails, SvgComponent$E as Spots, SvgComponent$A as Sso, SvgComponent$C as StickerPlus, SvgComponent$B as Success, SvgComponent$q as SwitchOff, SvgComponent$z as Tablet, SvgComponent$y as Tasks, SvgComponent$x as Team, SvgComponent$w as TimelineHandle, SvgComponent$v as Timer, SvgComponent$u as TooltipArrowDown, SvgComponent$t as TooltipArrowLeft, SvgComponent$r as TooltipArrowRight, SvgComponent$s as TooltipArrowUp, SvgComponent$n as Trash, SvgComponent$p as TrendDown, SvgComponent$o as TrendUp, SvgComponent as Trim, SvgComponent$m as Trophy, SvgComponent$l as Tune, SvgComponent$j as Twentythree, SvgComponent$k as TwentythreeVideo, SvgComponent$i as Twitter, SvgComponent$h as Unassign, SvgComponent$g as Upload, SvgComponent$e as Video, SvgComponent$f as VideoAdd, SvgComponent$d as Viewers, SvgComponent$c as Views, SvgComponent$a as Vimeo, SvgComponent$b as WalletGiftcard, SvgComponent$8 as Warning, SvgComponent$9 as Web, SvgComponent$7 as WidgetPvCalendly, SvgComponent$6 as WidgetPvEmbedly, SvgComponent$5 as Wistia, SvgComponent$4 as Youtube, SvgComponent$3 as YoutubeAlt };
